(function () {
// Import and use some of the 'solid', 'regular', 'light' and 'brand' themes of FontAwesome 5 Free/PRO (.npmrc is required)
// We only add icons to the library that we actually use in frontend to keep the bundle size as small as possible
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */ function $2f7ebf3a194ce8e5$var$_defineProperty(e, r, t) {
    return (r = $2f7ebf3a194ce8e5$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2f7ebf3a194ce8e5$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $2f7ebf3a194ce8e5$var$_setPrototypeOf(t, e);
}
function $2f7ebf3a194ce8e5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2f7ebf3a194ce8e5$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2f7ebf3a194ce8e5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2f7ebf3a194ce8e5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2f7ebf3a194ce8e5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2f7ebf3a194ce8e5$var$_setPrototypeOf(t, e) {
    return $2f7ebf3a194ce8e5$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $2f7ebf3a194ce8e5$var$_setPrototypeOf(t, e);
}
function $2f7ebf3a194ce8e5$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2f7ebf3a194ce8e5$var$_toPropertyKey(t) {
    var i = $2f7ebf3a194ce8e5$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $2f7ebf3a194ce8e5$var$_wrapRegExp() {
    $2f7ebf3a194ce8e5$var$_wrapRegExp = function(e, r) {
        return new BabelRegExp(e, void 0, r);
    };
    var e = RegExp.prototype, r = new WeakMap();
    function BabelRegExp(e, t, p) {
        var o = RegExp(e, t);
        return r.set(o, p || r.get(e)), $2f7ebf3a194ce8e5$var$_setPrototypeOf(o, BabelRegExp.prototype);
    }
    function buildGroups(e, t) {
        var p = r.get(t);
        return Object.keys(p).reduce(function(r, t) {
            var o = p[t];
            if ("number" == typeof o) r[t] = e[o];
            else {
                for(var i = 0; void 0 === e[o[i]] && i + 1 < o.length;)i++;
                r[t] = e[o[i]];
            }
            return r;
        }, Object.create(null));
    }
    return $2f7ebf3a194ce8e5$var$_inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(r) {
        var t = e.exec.call(this, r);
        if (t) {
            t.groups = buildGroups(t, this);
            var p = t.indices;
            p && (p.groups = buildGroups(p, this));
        }
        return t;
    }, BabelRegExp.prototype[Symbol.replace] = function(t, p) {
        if ("string" == typeof p) {
            var o = r.get(this);
            return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function(e, r) {
                var t = o[r];
                return "$" + (Array.isArray(t) ? t.join("$") : t);
            }));
        }
        if ("function" == typeof p) {
            var i = this;
            return e[Symbol.replace].call(this, t, function() {
                var e = arguments;
                return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e);
            });
        }
        return e[Symbol.replace].call(this, t, p);
    }, $2f7ebf3a194ce8e5$var$_wrapRegExp.apply(this, arguments);
}
const $2f7ebf3a194ce8e5$var$noop = ()=>{};
let $2f7ebf3a194ce8e5$var$_WINDOW = {};
let $2f7ebf3a194ce8e5$var$_DOCUMENT = {};
let $2f7ebf3a194ce8e5$var$_MUTATION_OBSERVER = null;
let $2f7ebf3a194ce8e5$var$_PERFORMANCE = {
    mark: $2f7ebf3a194ce8e5$var$noop,
    measure: $2f7ebf3a194ce8e5$var$noop
};
try {
    if (typeof window !== 'undefined') $2f7ebf3a194ce8e5$var$_WINDOW = window;
    if (typeof document !== 'undefined') $2f7ebf3a194ce8e5$var$_DOCUMENT = document;
    if (typeof MutationObserver !== 'undefined') $2f7ebf3a194ce8e5$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== 'undefined') $2f7ebf3a194ce8e5$var$_PERFORMANCE = performance;
} catch (e) {}
const { userAgent: $2f7ebf3a194ce8e5$var$userAgent = '' } = $2f7ebf3a194ce8e5$var$_WINDOW.navigator || {};
const $2f7ebf3a194ce8e5$var$WINDOW = $2f7ebf3a194ce8e5$var$_WINDOW;
const $2f7ebf3a194ce8e5$var$DOCUMENT = $2f7ebf3a194ce8e5$var$_DOCUMENT;
const $2f7ebf3a194ce8e5$var$MUTATION_OBSERVER = $2f7ebf3a194ce8e5$var$_MUTATION_OBSERVER;
const $2f7ebf3a194ce8e5$var$PERFORMANCE = $2f7ebf3a194ce8e5$var$_PERFORMANCE;
const $2f7ebf3a194ce8e5$var$IS_BROWSER = !!$2f7ebf3a194ce8e5$var$WINDOW.document;
const $2f7ebf3a194ce8e5$var$IS_DOM = !!$2f7ebf3a194ce8e5$var$DOCUMENT.documentElement && !!$2f7ebf3a194ce8e5$var$DOCUMENT.head && typeof $2f7ebf3a194ce8e5$var$DOCUMENT.addEventListener === 'function' && typeof $2f7ebf3a194ce8e5$var$DOCUMENT.createElement === 'function';
const $2f7ebf3a194ce8e5$var$IS_IE = ~$2f7ebf3a194ce8e5$var$userAgent.indexOf('MSIE') || ~$2f7ebf3a194ce8e5$var$userAgent.indexOf('Trident/');
var $2f7ebf3a194ce8e5$var$p = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, $2f7ebf3a194ce8e5$var$g = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i;
var $2f7ebf3a194ce8e5$var$S = {
    classic: {
        fa: "solid",
        fas: "solid",
        "fa-solid": "solid",
        far: "regular",
        "fa-regular": "regular",
        fal: "light",
        "fa-light": "light",
        fat: "thin",
        "fa-thin": "thin",
        fab: "brands",
        "fa-brands": "brands"
    },
    duotone: {
        fa: "solid",
        fad: "solid",
        "fa-solid": "solid",
        "fa-duotone": "solid",
        fadr: "regular",
        "fa-regular": "regular",
        fadl: "light",
        "fa-light": "light",
        fadt: "thin",
        "fa-thin": "thin"
    },
    sharp: {
        fa: "solid",
        fass: "solid",
        "fa-solid": "solid",
        fasr: "regular",
        "fa-regular": "regular",
        fasl: "light",
        "fa-light": "light",
        fast: "thin",
        "fa-thin": "thin"
    },
    "sharp-duotone": {
        fa: "solid",
        fasds: "solid",
        "fa-solid": "solid",
        fasdr: "regular",
        "fa-regular": "regular",
        fasdl: "light",
        "fa-light": "light",
        fasdt: "thin",
        "fa-thin": "thin"
    }
}, $2f7ebf3a194ce8e5$var$A = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
}, $2f7ebf3a194ce8e5$var$P = [
    "fa-classic",
    "fa-duotone",
    "fa-sharp",
    "fa-sharp-duotone"
];
var $2f7ebf3a194ce8e5$var$s = "classic", $2f7ebf3a194ce8e5$var$t = "duotone", $2f7ebf3a194ce8e5$var$r = "sharp", $2f7ebf3a194ce8e5$var$o = "sharp-duotone", $2f7ebf3a194ce8e5$var$L = [
    $2f7ebf3a194ce8e5$var$s,
    $2f7ebf3a194ce8e5$var$t,
    $2f7ebf3a194ce8e5$var$r,
    $2f7ebf3a194ce8e5$var$o
];
var $2f7ebf3a194ce8e5$var$G = {
    classic: {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
    },
    duotone: {
        900: "fad",
        400: "fadr",
        300: "fadl",
        100: "fadt"
    },
    sharp: {
        900: "fass",
        400: "fasr",
        300: "fasl",
        100: "fast"
    },
    "sharp-duotone": {
        900: "fasds",
        400: "fasdr",
        300: "fasdl",
        100: "fasdt"
    }
};
var $2f7ebf3a194ce8e5$var$lt = {
    "Font Awesome 6 Free": {
        900: "fas",
        400: "far"
    },
    "Font Awesome 6 Pro": {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
    },
    "Font Awesome 6 Brands": {
        400: "fab",
        normal: "fab"
    },
    "Font Awesome 6 Duotone": {
        900: "fad",
        400: "fadr",
        normal: "fadr",
        300: "fadl",
        100: "fadt"
    },
    "Font Awesome 6 Sharp": {
        900: "fass",
        400: "fasr",
        normal: "fasr",
        300: "fasl",
        100: "fast"
    },
    "Font Awesome 6 Sharp Duotone": {
        900: "fasds",
        400: "fasdr",
        normal: "fasdr",
        300: "fasdl",
        100: "fasdt"
    }
};
var $2f7ebf3a194ce8e5$var$pt = new Map([
    [
        "classic",
        {
            defaultShortPrefixId: "fas",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin",
                "brands"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "sharp",
        {
            defaultShortPrefixId: "fass",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "duotone",
        {
            defaultShortPrefixId: "fad",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "sharp-duotone",
        {
            defaultShortPrefixId: "fasds",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ]
]), $2f7ebf3a194ce8e5$var$xt = {
    classic: {
        solid: "fas",
        regular: "far",
        light: "fal",
        thin: "fat",
        brands: "fab"
    },
    duotone: {
        solid: "fad",
        regular: "fadr",
        light: "fadl",
        thin: "fadt"
    },
    sharp: {
        solid: "fass",
        regular: "fasr",
        light: "fasl",
        thin: "fast"
    },
    "sharp-duotone": {
        solid: "fasds",
        regular: "fasdr",
        light: "fasdl",
        thin: "fasdt"
    }
};
var $2f7ebf3a194ce8e5$var$Ft = [
    "fak",
    "fa-kit",
    "fakd",
    "fa-kit-duotone"
], $2f7ebf3a194ce8e5$var$St = {
    kit: {
        fak: "kit",
        "fa-kit": "kit"
    },
    "kit-duotone": {
        fakd: "kit-duotone",
        "fa-kit-duotone": "kit-duotone"
    }
}, $2f7ebf3a194ce8e5$var$At = [
    "kit"
];
var $2f7ebf3a194ce8e5$var$Ct = {
    kit: {
        "fa-kit": "fak"
    },
    "kit-duotone": {
        "fa-kit-duotone": "fakd"
    }
};
var $2f7ebf3a194ce8e5$var$Lt = [
    "fak",
    "fakd"
], $2f7ebf3a194ce8e5$var$Wt = {
    kit: {
        fak: "fa-kit"
    },
    "kit-duotone": {
        fakd: "fa-kit-duotone"
    }
};
var $2f7ebf3a194ce8e5$var$Et = {
    kit: {
        kit: "fak"
    },
    "kit-duotone": {
        "kit-duotone": "fakd"
    }
};
var $2f7ebf3a194ce8e5$var$t$1 = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
}, $2f7ebf3a194ce8e5$var$r$1 = [
    "fa-classic",
    "fa-duotone",
    "fa-sharp",
    "fa-sharp-duotone"
];
var $2f7ebf3a194ce8e5$var$bt$1 = [
    "fak",
    "fa-kit",
    "fakd",
    "fa-kit-duotone"
];
var $2f7ebf3a194ce8e5$var$Yt = {
    "Font Awesome Kit": {
        400: "fak",
        normal: "fak"
    },
    "Font Awesome Kit Duotone": {
        400: "fakd",
        normal: "fakd"
    }
};
var $2f7ebf3a194ce8e5$var$ua = {
    classic: {
        "fa-brands": "fab",
        "fa-duotone": "fad",
        "fa-light": "fal",
        "fa-regular": "far",
        "fa-solid": "fas",
        "fa-thin": "fat"
    },
    duotone: {
        "fa-regular": "fadr",
        "fa-light": "fadl",
        "fa-thin": "fadt"
    },
    sharp: {
        "fa-solid": "fass",
        "fa-regular": "fasr",
        "fa-light": "fasl",
        "fa-thin": "fast"
    },
    "sharp-duotone": {
        "fa-solid": "fasds",
        "fa-regular": "fasdr",
        "fa-light": "fasdl",
        "fa-thin": "fasdt"
    }
}, $2f7ebf3a194ce8e5$var$I$1 = {
    classic: [
        "fas",
        "far",
        "fal",
        "fat",
        "fad"
    ],
    duotone: [
        "fadr",
        "fadl",
        "fadt"
    ],
    sharp: [
        "fass",
        "fasr",
        "fasl",
        "fast"
    ],
    "sharp-duotone": [
        "fasds",
        "fasdr",
        "fasdl",
        "fasdt"
    ]
}, $2f7ebf3a194ce8e5$var$ga = {
    classic: {
        fab: "fa-brands",
        fad: "fa-duotone",
        fal: "fa-light",
        far: "fa-regular",
        fas: "fa-solid",
        fat: "fa-thin"
    },
    duotone: {
        fadr: "fa-regular",
        fadl: "fa-light",
        fadt: "fa-thin"
    },
    sharp: {
        fass: "fa-solid",
        fasr: "fa-regular",
        fasl: "fa-light",
        fast: "fa-thin"
    },
    "sharp-duotone": {
        fasds: "fa-solid",
        fasdr: "fa-regular",
        fasdl: "fa-light",
        fasdt: "fa-thin"
    }
}, $2f7ebf3a194ce8e5$var$x = [
    "fa-solid",
    "fa-regular",
    "fa-light",
    "fa-thin",
    "fa-duotone",
    "fa-brands"
], $2f7ebf3a194ce8e5$var$Ia = [
    "fa",
    "fas",
    "far",
    "fal",
    "fat",
    "fad",
    "fadr",
    "fadl",
    "fadt",
    "fab",
    "fass",
    "fasr",
    "fasl",
    "fast",
    "fasds",
    "fasdr",
    "fasdl",
    "fasdt",
    ...$2f7ebf3a194ce8e5$var$r$1,
    ...$2f7ebf3a194ce8e5$var$x
], $2f7ebf3a194ce8e5$var$m$1 = [
    "solid",
    "regular",
    "light",
    "thin",
    "duotone",
    "brands"
], $2f7ebf3a194ce8e5$var$c$1 = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
], $2f7ebf3a194ce8e5$var$F$1 = $2f7ebf3a194ce8e5$var$c$1.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]), $2f7ebf3a194ce8e5$var$ma = [
    ...Object.keys($2f7ebf3a194ce8e5$var$I$1),
    ...$2f7ebf3a194ce8e5$var$m$1,
    "2xs",
    "xs",
    "sm",
    "lg",
    "xl",
    "2xl",
    "beat",
    "border",
    "fade",
    "beat-fade",
    "bounce",
    "flip-both",
    "flip-horizontal",
    "flip-vertical",
    "flip",
    "fw",
    "inverse",
    "layers-counter",
    "layers-text",
    "layers",
    "li",
    "pull-left",
    "pull-right",
    "pulse",
    "rotate-180",
    "rotate-270",
    "rotate-90",
    "rotate-by",
    "shake",
    "spin-pulse",
    "spin-reverse",
    "spin",
    "stack-1x",
    "stack-2x",
    "stack",
    "ul",
    $2f7ebf3a194ce8e5$var$t$1.GROUP,
    $2f7ebf3a194ce8e5$var$t$1.SWAP_OPACITY,
    $2f7ebf3a194ce8e5$var$t$1.PRIMARY,
    $2f7ebf3a194ce8e5$var$t$1.SECONDARY
].concat($2f7ebf3a194ce8e5$var$c$1.map((a)=>"".concat(a, "x"))).concat($2f7ebf3a194ce8e5$var$F$1.map((a)=>"w-".concat(a)));
var $2f7ebf3a194ce8e5$var$wa = {
    "Font Awesome 5 Free": {
        900: "fas",
        400: "far"
    },
    "Font Awesome 5 Pro": {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal"
    },
    "Font Awesome 5 Brands": {
        400: "fab",
        normal: "fab"
    },
    "Font Awesome 5 Duotone": {
        900: "fad"
    }
};
const $2f7ebf3a194ce8e5$var$NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
const $2f7ebf3a194ce8e5$var$UNITS_IN_GRID = 16;
const $2f7ebf3a194ce8e5$var$DEFAULT_CSS_PREFIX = 'fa';
const $2f7ebf3a194ce8e5$var$DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
const $2f7ebf3a194ce8e5$var$DATA_FA_I2SVG = 'data-fa-i2svg';
const $2f7ebf3a194ce8e5$var$DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
const $2f7ebf3a194ce8e5$var$DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
const $2f7ebf3a194ce8e5$var$DATA_PREFIX = 'data-prefix';
const $2f7ebf3a194ce8e5$var$DATA_ICON = 'data-icon';
const $2f7ebf3a194ce8e5$var$HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
const $2f7ebf3a194ce8e5$var$MUTATION_APPROACH_ASYNC = 'async';
const $2f7ebf3a194ce8e5$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    'HTML',
    'HEAD',
    'STYLE',
    'SCRIPT'
];
const $2f7ebf3a194ce8e5$var$PRODUCTION = (()=>{
    try {
        return true;
    } catch (e$$1) {
        return false;
    }
})();
function $2f7ebf3a194ce8e5$var$familyProxy(obj) {
    // Defaults to the classic family if family is not available
    return new Proxy(obj, {
        get (target, prop) {
            return prop in target ? target[prop] : target[$2f7ebf3a194ce8e5$var$s];
        }
    });
}
const $2f7ebf3a194ce8e5$var$_PREFIX_TO_STYLE = $2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$S);
// We changed FACSSClassesToStyleId in the icons repo to be canonical and as such, "classic" family does not have any
// duotone styles.  But we do still need duotone in _PREFIX_TO_STYLE below, so we are manually adding
// {'fa-duotone': 'duotone'}
$2f7ebf3a194ce8e5$var$_PREFIX_TO_STYLE[$2f7ebf3a194ce8e5$var$s] = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, {
    'fa-duotone': 'duotone'
}), $2f7ebf3a194ce8e5$var$S[$2f7ebf3a194ce8e5$var$s]), $2f7ebf3a194ce8e5$var$St['kit']), $2f7ebf3a194ce8e5$var$St['kit-duotone']);
const $2f7ebf3a194ce8e5$var$PREFIX_TO_STYLE = $2f7ebf3a194ce8e5$var$familyProxy($2f7ebf3a194ce8e5$var$_PREFIX_TO_STYLE);
const $2f7ebf3a194ce8e5$var$_STYLE_TO_PREFIX = $2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$xt);
// We changed FAStyleIdToShortPrefixId in the icons repo to be canonical and as such, "classic" family does not have any
// duotone styles.  But we do still need duotone in _STYLE_TO_PREFIX below, so we are manually adding {duotone: 'fad'}
$2f7ebf3a194ce8e5$var$_STYLE_TO_PREFIX[$2f7ebf3a194ce8e5$var$s] = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, {
    duotone: 'fad'
}), $2f7ebf3a194ce8e5$var$_STYLE_TO_PREFIX[$2f7ebf3a194ce8e5$var$s]), $2f7ebf3a194ce8e5$var$Et['kit']), $2f7ebf3a194ce8e5$var$Et['kit-duotone']);
const $2f7ebf3a194ce8e5$var$STYLE_TO_PREFIX = $2f7ebf3a194ce8e5$var$familyProxy($2f7ebf3a194ce8e5$var$_STYLE_TO_PREFIX);
const $2f7ebf3a194ce8e5$var$_PREFIX_TO_LONG_STYLE = $2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$ga);
$2f7ebf3a194ce8e5$var$_PREFIX_TO_LONG_STYLE[$2f7ebf3a194ce8e5$var$s] = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$_PREFIX_TO_LONG_STYLE[$2f7ebf3a194ce8e5$var$s]), $2f7ebf3a194ce8e5$var$Wt['kit']);
const $2f7ebf3a194ce8e5$var$PREFIX_TO_LONG_STYLE = $2f7ebf3a194ce8e5$var$familyProxy($2f7ebf3a194ce8e5$var$_PREFIX_TO_LONG_STYLE);
const $2f7ebf3a194ce8e5$var$_LONG_STYLE_TO_PREFIX = $2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$ua);
$2f7ebf3a194ce8e5$var$_LONG_STYLE_TO_PREFIX[$2f7ebf3a194ce8e5$var$s] = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$_LONG_STYLE_TO_PREFIX[$2f7ebf3a194ce8e5$var$s]), $2f7ebf3a194ce8e5$var$Ct['kit']);
const $2f7ebf3a194ce8e5$var$LONG_STYLE_TO_PREFIX = $2f7ebf3a194ce8e5$var$familyProxy($2f7ebf3a194ce8e5$var$_LONG_STYLE_TO_PREFIX);
const $2f7ebf3a194ce8e5$var$ICON_SELECTION_SYNTAX_PATTERN = $2f7ebf3a194ce8e5$var$p; // eslint-disable-line no-useless-escape
const $2f7ebf3a194ce8e5$var$LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
const $2f7ebf3a194ce8e5$var$FONT_FAMILY_PATTERN = $2f7ebf3a194ce8e5$var$g;
const $2f7ebf3a194ce8e5$var$_FONT_WEIGHT_TO_PREFIX = $2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$G);
const $2f7ebf3a194ce8e5$var$FONT_WEIGHT_TO_PREFIX = $2f7ebf3a194ce8e5$var$familyProxy($2f7ebf3a194ce8e5$var$_FONT_WEIGHT_TO_PREFIX);
const $2f7ebf3a194ce8e5$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    'class',
    'data-prefix',
    'data-icon',
    'data-fa-transform',
    'data-fa-mask'
];
const $2f7ebf3a194ce8e5$var$DUOTONE_CLASSES = $2f7ebf3a194ce8e5$var$A;
const $2f7ebf3a194ce8e5$var$RESERVED_CLASSES = [
    ...$2f7ebf3a194ce8e5$var$At,
    ...$2f7ebf3a194ce8e5$var$ma
];
const $2f7ebf3a194ce8e5$var$initial = $2f7ebf3a194ce8e5$var$WINDOW.FontAwesomeConfig || {};
function $2f7ebf3a194ce8e5$var$getAttrConfig(attr) {
    var element = $2f7ebf3a194ce8e5$var$DOCUMENT.querySelector('script[' + attr + ']');
    if (element) return element.getAttribute(attr);
}
function $2f7ebf3a194ce8e5$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    if (val === '') return true;
    if (val === 'false') return false;
    if (val === 'true') return true;
    return val;
}
if ($2f7ebf3a194ce8e5$var$DOCUMENT && typeof $2f7ebf3a194ce8e5$var$DOCUMENT.querySelector === 'function') {
    const attrs = [
        [
            'data-family-prefix',
            'familyPrefix'
        ],
        [
            'data-css-prefix',
            'cssPrefix'
        ],
        [
            'data-family-default',
            'familyDefault'
        ],
        [
            'data-style-default',
            'styleDefault'
        ],
        [
            'data-replacement-class',
            'replacementClass'
        ],
        [
            'data-auto-replace-svg',
            'autoReplaceSvg'
        ],
        [
            'data-auto-add-css',
            'autoAddCss'
        ],
        [
            'data-auto-a11y',
            'autoA11y'
        ],
        [
            'data-search-pseudo-elements',
            'searchPseudoElements'
        ],
        [
            'data-observe-mutations',
            'observeMutations'
        ],
        [
            'data-mutate-approach',
            'mutateApproach'
        ],
        [
            'data-keep-original-source',
            'keepOriginalSource'
        ],
        [
            'data-measure-performance',
            'measurePerformance'
        ],
        [
            'data-show-missing-icons',
            'showMissingIcons'
        ]
    ];
    attrs.forEach((_ref)=>{
        let [attr, key] = _ref;
        const val = $2f7ebf3a194ce8e5$var$coerce($2f7ebf3a194ce8e5$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $2f7ebf3a194ce8e5$var$initial[key] = val;
    });
}
const $2f7ebf3a194ce8e5$var$_default = {
    styleDefault: 'solid',
    familyDefault: $2f7ebf3a194ce8e5$var$s,
    cssPrefix: $2f7ebf3a194ce8e5$var$DEFAULT_CSS_PREFIX,
    replacementClass: $2f7ebf3a194ce8e5$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: 'async',
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
};
// familyPrefix is deprecated but we must still support it if present
if ($2f7ebf3a194ce8e5$var$initial.familyPrefix) $2f7ebf3a194ce8e5$var$initial.cssPrefix = $2f7ebf3a194ce8e5$var$initial.familyPrefix;
const $2f7ebf3a194ce8e5$var$_config = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$_default), $2f7ebf3a194ce8e5$var$initial);
if (!$2f7ebf3a194ce8e5$var$_config.autoReplaceSvg) $2f7ebf3a194ce8e5$var$_config.observeMutations = false;
const $2f7ebf3a194ce8e5$var$config = {};
Object.keys($2f7ebf3a194ce8e5$var$_default).forEach((key)=>{
    Object.defineProperty($2f7ebf3a194ce8e5$var$config, key, {
        enumerable: true,
        set: function(val) {
            $2f7ebf3a194ce8e5$var$_config[key] = val;
            $2f7ebf3a194ce8e5$var$_onChangeCb.forEach((cb)=>cb($2f7ebf3a194ce8e5$var$config));
        },
        get: function() {
            return $2f7ebf3a194ce8e5$var$_config[key];
        }
    });
});
// familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0
Object.defineProperty($2f7ebf3a194ce8e5$var$config, 'familyPrefix', {
    enumerable: true,
    set: function(val) {
        $2f7ebf3a194ce8e5$var$_config.cssPrefix = val;
        $2f7ebf3a194ce8e5$var$_onChangeCb.forEach((cb)=>cb($2f7ebf3a194ce8e5$var$config));
    },
    get: function() {
        return $2f7ebf3a194ce8e5$var$_config.cssPrefix;
    }
});
$2f7ebf3a194ce8e5$var$WINDOW.FontAwesomeConfig = $2f7ebf3a194ce8e5$var$config;
const $2f7ebf3a194ce8e5$var$_onChangeCb = [];
function $2f7ebf3a194ce8e5$var$onChange(cb) {
    $2f7ebf3a194ce8e5$var$_onChangeCb.push(cb);
    return ()=>{
        $2f7ebf3a194ce8e5$var$_onChangeCb.splice($2f7ebf3a194ce8e5$var$_onChangeCb.indexOf(cb), 1);
    };
}
const $2f7ebf3a194ce8e5$var$d$2 = $2f7ebf3a194ce8e5$var$UNITS_IN_GRID;
const $2f7ebf3a194ce8e5$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $2f7ebf3a194ce8e5$var$insertCss(css) {
    if (!css || !$2f7ebf3a194ce8e5$var$IS_DOM) return;
    const style = $2f7ebf3a194ce8e5$var$DOCUMENT.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    const headChildren = $2f7ebf3a194ce8e5$var$DOCUMENT.head.childNodes;
    let beforeChild = null;
    for(let i = headChildren.length - 1; i > -1; i--){
        const child = headChildren[i];
        const tagName = (child.tagName || '').toUpperCase();
        if ([
            'STYLE',
            'LINK'
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $2f7ebf3a194ce8e5$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
const $2f7ebf3a194ce8e5$var$idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function $2f7ebf3a194ce8e5$var$nextUniqueId() {
    let size = 12;
    let id = '';
    while(size-- > 0)id += $2f7ebf3a194ce8e5$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $2f7ebf3a194ce8e5$var$toArray(obj) {
    const array = [];
    for(let i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $2f7ebf3a194ce8e5$var$classArray(node) {
    if (node.classList) return $2f7ebf3a194ce8e5$var$toArray(node.classList);
    else return (node.getAttribute('class') || '').split(' ').filter((i)=>i);
}
function $2f7ebf3a194ce8e5$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function $2f7ebf3a194ce8e5$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce((acc, attributeName)=>{
        return acc + "".concat(attributeName, "=\"").concat($2f7ebf3a194ce8e5$var$htmlEscape(attributes[attributeName]), "\" ");
    }, '').trim();
}
function $2f7ebf3a194ce8e5$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce((acc, styleName)=>{
        return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
    }, '');
}
function $2f7ebf3a194ce8e5$var$transformIsMeaningful(transform) {
    return transform.size !== $2f7ebf3a194ce8e5$var$meaninglessTransform.size || transform.x !== $2f7ebf3a194ce8e5$var$meaninglessTransform.x || transform.y !== $2f7ebf3a194ce8e5$var$meaninglessTransform.y || transform.rotate !== $2f7ebf3a194ce8e5$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $2f7ebf3a194ce8e5$var$transformForSvg(_ref) {
    let { transform: transform, containerWidth: containerWidth, iconWidth: iconWidth } = _ref;
    const outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    const innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    const innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    const innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    const inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    const path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $2f7ebf3a194ce8e5$var$transformForCss(_ref2) {
    let { transform: transform, width: width = $2f7ebf3a194ce8e5$var$UNITS_IN_GRID, height: height = $2f7ebf3a194ce8e5$var$UNITS_IN_GRID, startCentered: startCentered = false } = _ref2;
    let val = '';
    if (startCentered && $2f7ebf3a194ce8e5$var$IS_IE) val += "translate(".concat(transform.x / $2f7ebf3a194ce8e5$var$d$2 - width / 2, "em, ").concat(transform.y / $2f7ebf3a194ce8e5$var$d$2 - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $2f7ebf3a194ce8e5$var$d$2, "em), calc(-50% + ").concat(transform.y / $2f7ebf3a194ce8e5$var$d$2, "em)) ");
    else val += "translate(".concat(transform.x / $2f7ebf3a194ce8e5$var$d$2, "em, ").concat(transform.y / $2f7ebf3a194ce8e5$var$d$2, "em) ");
    val += "scale(".concat(transform.size / $2f7ebf3a194ce8e5$var$d$2 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $2f7ebf3a194ce8e5$var$d$2 * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $2f7ebf3a194ce8e5$var$baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Free\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Free\";\n  --fa-font-light: normal 300 1em/1 \"Font Awesome 6 Pro\";\n  --fa-font-thin: normal 100 1em/1 \"Font Awesome 6 Pro\";\n  --fa-font-duotone: normal 900 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-duotone-regular: normal 400 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-duotone-light: normal 300 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-duotone-thin: normal 100 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n  --fa-font-sharp-solid: normal 900 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-regular: normal 400 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-light: normal 300 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-thin: normal 100 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-duotone-solid: normal 900 1em/1 \"Font Awesome 6 Sharp Duotone\";\n  --fa-font-sharp-duotone-regular: normal 400 1em/1 \"Font Awesome 6 Sharp Duotone\";\n  --fa-font-sharp-duotone-light: normal 300 1em/1 \"Font Awesome 6 Sharp Duotone\";\n  --fa-font-sharp-duotone-thin: normal 100 1em/1 \"Font Awesome 6 Sharp Duotone\";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-counter-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(-1 * var(--fa-li-width, 2em));\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  animation-name: fa-beat;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  animation-name: fa-bounce;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  animation-name: fa-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  animation-name: fa-beat-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  animation-name: fa-flip;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  animation-name: fa-shake;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  animation-name: fa-spin;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 2s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  animation-name: fa-spin;\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    animation-delay: -1ms;\n    animation-duration: 1ms;\n    animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    transform: scale(1);\n  }\n  45% {\n    transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-shake {\n  0% {\n    transform: rotate(-15deg);\n  }\n  4% {\n    transform: rotate(15deg);\n  }\n  8%, 24% {\n    transform: rotate(-18deg);\n  }\n  12%, 28% {\n    transform: rotate(18deg);\n  }\n  16% {\n    transform: rotate(-22deg);\n  }\n  20% {\n    transform: rotate(22deg);\n  }\n  32% {\n    transform: rotate(-12deg);\n  }\n  36% {\n    transform: rotate(12deg);\n  }\n  40%, 100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  transform: rotate(var(--fa-rotate-angle, 0));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}";
function $2f7ebf3a194ce8e5$var$css() {
    const dcp = $2f7ebf3a194ce8e5$var$DEFAULT_CSS_PREFIX;
    const drc = $2f7ebf3a194ce8e5$var$DEFAULT_REPLACEMENT_CLASS;
    const fp = $2f7ebf3a194ce8e5$var$config.cssPrefix;
    const rc = $2f7ebf3a194ce8e5$var$config.replacementClass;
    let s = $2f7ebf3a194ce8e5$var$baseStyles;
    if (fp !== dcp || rc !== drc) {
        const dPatt = new RegExp("\\.".concat(dcp, "\\-"), 'g');
        const customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), 'g');
        const rPatt = new RegExp("\\.".concat(drc), 'g');
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
let $2f7ebf3a194ce8e5$var$_cssInserted = false;
function $2f7ebf3a194ce8e5$var$ensureCss() {
    if ($2f7ebf3a194ce8e5$var$config.autoAddCss && !$2f7ebf3a194ce8e5$var$_cssInserted) {
        $2f7ebf3a194ce8e5$var$insertCss($2f7ebf3a194ce8e5$var$css());
        $2f7ebf3a194ce8e5$var$_cssInserted = true;
    }
}
var $2f7ebf3a194ce8e5$var$InjectCSS = {
    mixout () {
        return {
            dom: {
                css: $2f7ebf3a194ce8e5$var$css,
                insertCss: $2f7ebf3a194ce8e5$var$ensureCss
            }
        };
    },
    hooks () {
        return {
            beforeDOMElementCreation () {
                $2f7ebf3a194ce8e5$var$ensureCss();
            },
            beforeI2svg () {
                $2f7ebf3a194ce8e5$var$ensureCss();
            }
        };
    }
};
const $2f7ebf3a194ce8e5$var$w = $2f7ebf3a194ce8e5$var$WINDOW || {};
if (!$2f7ebf3a194ce8e5$var$w[$2f7ebf3a194ce8e5$var$NAMESPACE_IDENTIFIER]) $2f7ebf3a194ce8e5$var$w[$2f7ebf3a194ce8e5$var$NAMESPACE_IDENTIFIER] = {};
if (!$2f7ebf3a194ce8e5$var$w[$2f7ebf3a194ce8e5$var$NAMESPACE_IDENTIFIER].styles) $2f7ebf3a194ce8e5$var$w[$2f7ebf3a194ce8e5$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$2f7ebf3a194ce8e5$var$w[$2f7ebf3a194ce8e5$var$NAMESPACE_IDENTIFIER].hooks) $2f7ebf3a194ce8e5$var$w[$2f7ebf3a194ce8e5$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$2f7ebf3a194ce8e5$var$w[$2f7ebf3a194ce8e5$var$NAMESPACE_IDENTIFIER].shims) $2f7ebf3a194ce8e5$var$w[$2f7ebf3a194ce8e5$var$NAMESPACE_IDENTIFIER].shims = [];
var $2f7ebf3a194ce8e5$var$namespace = $2f7ebf3a194ce8e5$var$w[$2f7ebf3a194ce8e5$var$NAMESPACE_IDENTIFIER];
const $2f7ebf3a194ce8e5$var$functions = [];
const $2f7ebf3a194ce8e5$var$listener = function() {
    $2f7ebf3a194ce8e5$var$DOCUMENT.removeEventListener('DOMContentLoaded', $2f7ebf3a194ce8e5$var$listener);
    $2f7ebf3a194ce8e5$var$loaded = 1;
    $2f7ebf3a194ce8e5$var$functions.map((fn)=>fn());
};
let $2f7ebf3a194ce8e5$var$loaded = false;
if ($2f7ebf3a194ce8e5$var$IS_DOM) {
    $2f7ebf3a194ce8e5$var$loaded = ($2f7ebf3a194ce8e5$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($2f7ebf3a194ce8e5$var$DOCUMENT.readyState);
    if (!$2f7ebf3a194ce8e5$var$loaded) $2f7ebf3a194ce8e5$var$DOCUMENT.addEventListener('DOMContentLoaded', $2f7ebf3a194ce8e5$var$listener);
}
function $2f7ebf3a194ce8e5$var$domready(fn) {
    if (!$2f7ebf3a194ce8e5$var$IS_DOM) return;
    $2f7ebf3a194ce8e5$var$loaded ? setTimeout(fn, 0) : $2f7ebf3a194ce8e5$var$functions.push(fn);
}
function $2f7ebf3a194ce8e5$var$toHtml(abstractNodes) {
    const { tag: tag, attributes: attributes = {}, children: children = [] } = abstractNodes;
    if (typeof abstractNodes === 'string') return $2f7ebf3a194ce8e5$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($2f7ebf3a194ce8e5$var$joinAttributes(attributes), ">").concat(children.map($2f7ebf3a194ce8e5$var$toHtml).join(''), "</").concat(tag, ">");
}
function $2f7ebf3a194ce8e5$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $2f7ebf3a194ce8e5$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $2f7ebf3a194ce8e5$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $2f7ebf3a194ce8e5$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ function $2f7ebf3a194ce8e5$var$ucs2decode(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) // eslint-disable-line eqeqeq
            output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
function $2f7ebf3a194ce8e5$var$toHex(unicode) {
    const decoded = $2f7ebf3a194ce8e5$var$ucs2decode(unicode);
    return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function $2f7ebf3a194ce8e5$var$codePointAt(string, index) {
    const size = string.length;
    let first = string.charCodeAt(index);
    let second;
    if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
        second = string.charCodeAt(index + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
    return first;
}
function $2f7ebf3a194ce8e5$var$normalizeIcons(icons) {
    return Object.keys(icons).reduce((acc, iconName)=>{
        const icon = icons[iconName];
        const expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
}
function $2f7ebf3a194ce8e5$var$defineIcons(prefix, icons) {
    let params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { skipHooks: skipHooks = false } = params;
    const normalized = $2f7ebf3a194ce8e5$var$normalizeIcons(icons);
    if (typeof $2f7ebf3a194ce8e5$var$namespace.hooks.addPack === 'function' && !skipHooks) $2f7ebf3a194ce8e5$var$namespace.hooks.addPack(prefix, $2f7ebf3a194ce8e5$var$normalizeIcons(icons));
    else $2f7ebf3a194ce8e5$var$namespace.styles[prefix] = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$namespace.styles[prefix] || {}), normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === 'fas') $2f7ebf3a194ce8e5$var$defineIcons('fa', icons);
}
const $2f7ebf3a194ce8e5$var$duotonePathRe = [
    /*#__PURE__*/ $2f7ebf3a194ce8e5$var$_wrapRegExp(/path d="([^"]+)".*path d="([^"]+)"/, {
        d1: 1,
        d2: 2
    }),
    /*#__PURE__*/ $2f7ebf3a194ce8e5$var$_wrapRegExp(/path class="([^"]+)".*d="([^"]+)".*path class="([^"]+)".*d="([^"]+)"/, {
        cls1: 1,
        d1: 2,
        cls2: 3,
        d2: 4
    }),
    /*#__PURE__*/ $2f7ebf3a194ce8e5$var$_wrapRegExp(/path class="([^"]+)".*d="([^"]+)"/, {
        cls1: 1,
        d1: 2
    })
];
const { styles: $2f7ebf3a194ce8e5$var$styles, shims: $2f7ebf3a194ce8e5$var$shims } = $2f7ebf3a194ce8e5$var$namespace;
const $2f7ebf3a194ce8e5$var$FAMILY_NAMES = Object.keys($2f7ebf3a194ce8e5$var$PREFIX_TO_LONG_STYLE);
const $2f7ebf3a194ce8e5$var$PREFIXES_FOR_FAMILY = $2f7ebf3a194ce8e5$var$FAMILY_NAMES.reduce((acc, familyId)=>{
    acc[familyId] = Object.keys($2f7ebf3a194ce8e5$var$PREFIX_TO_LONG_STYLE[familyId]);
    return acc;
}, {});
let $2f7ebf3a194ce8e5$var$_defaultUsablePrefix = null;
let $2f7ebf3a194ce8e5$var$_byUnicode = {};
let $2f7ebf3a194ce8e5$var$_byLigature = {};
let $2f7ebf3a194ce8e5$var$_byOldName = {};
let $2f7ebf3a194ce8e5$var$_byOldUnicode = {};
let $2f7ebf3a194ce8e5$var$_byAlias = {};
function $2f7ebf3a194ce8e5$var$isReserved(name) {
    return ~$2f7ebf3a194ce8e5$var$RESERVED_CLASSES.indexOf(name);
}
function $2f7ebf3a194ce8e5$var$getIconName(cssPrefix, cls) {
    const parts = cls.split('-');
    const prefix = parts[0];
    const iconName = parts.slice(1).join('-');
    if (prefix === cssPrefix && iconName !== '' && !$2f7ebf3a194ce8e5$var$isReserved(iconName)) return iconName;
    else return null;
}
const $2f7ebf3a194ce8e5$var$build = ()=>{
    const lookup = (reducer)=>{
        return $2f7ebf3a194ce8e5$var$reduce($2f7ebf3a194ce8e5$var$styles, (o$$1, style, prefix)=>{
            o$$1[prefix] = $2f7ebf3a194ce8e5$var$reduce(style, reducer, {});
            return o$$1;
        }, {});
    };
    $2f7ebf3a194ce8e5$var$_byUnicode = lookup((acc, icon, iconName)=>{
        if (icon[3]) acc[icon[3]] = iconName;
        if (icon[2]) {
            const aliases = icon[2].filter((a$$1)=>{
                return typeof a$$1 === 'number';
            });
            aliases.forEach((alias)=>{
                acc[alias.toString(16)] = iconName;
            });
        }
        return acc;
    });
    $2f7ebf3a194ce8e5$var$_byLigature = lookup((acc, icon, iconName)=>{
        acc[iconName] = iconName;
        if (icon[2]) {
            const aliases = icon[2].filter((a$$1)=>{
                return typeof a$$1 === 'string';
            });
            aliases.forEach((alias)=>{
                acc[alias] = iconName;
            });
        }
        return acc;
    });
    $2f7ebf3a194ce8e5$var$_byAlias = lookup((acc, icon, iconName)=>{
        const aliases = icon[2];
        acc[iconName] = iconName;
        aliases.forEach((alias)=>{
            acc[alias] = iconName;
        });
        return acc;
    });
    // If we have a Kit, we can't determine if regular is available since we
    // could be auto-fetching it. We'll have to assume that it is available.
    const hasRegular = 'far' in $2f7ebf3a194ce8e5$var$styles || $2f7ebf3a194ce8e5$var$config.autoFetchSvg;
    const shimLookups = $2f7ebf3a194ce8e5$var$reduce($2f7ebf3a194ce8e5$var$shims, (acc, shim)=>{
        const maybeNameMaybeUnicode = shim[0];
        let prefix = shim[1];
        const iconName = shim[2];
        if (prefix === 'far' && !hasRegular) prefix = 'fas';
        if (typeof maybeNameMaybeUnicode === 'string') acc.names[maybeNameMaybeUnicode] = {
            prefix: prefix,
            iconName: iconName
        };
        if (typeof maybeNameMaybeUnicode === 'number') acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {
        names: {},
        unicodes: {}
    });
    $2f7ebf3a194ce8e5$var$_byOldName = shimLookups.names;
    $2f7ebf3a194ce8e5$var$_byOldUnicode = shimLookups.unicodes;
    $2f7ebf3a194ce8e5$var$_defaultUsablePrefix = $2f7ebf3a194ce8e5$var$getCanonicalPrefix($2f7ebf3a194ce8e5$var$config.styleDefault, {
        family: $2f7ebf3a194ce8e5$var$config.familyDefault
    });
};
$2f7ebf3a194ce8e5$var$onChange((c$$1)=>{
    $2f7ebf3a194ce8e5$var$_defaultUsablePrefix = $2f7ebf3a194ce8e5$var$getCanonicalPrefix(c$$1.styleDefault, {
        family: $2f7ebf3a194ce8e5$var$config.familyDefault
    });
});
$2f7ebf3a194ce8e5$var$build();
function $2f7ebf3a194ce8e5$var$byUnicode(prefix, unicode) {
    return ($2f7ebf3a194ce8e5$var$_byUnicode[prefix] || {})[unicode];
}
function $2f7ebf3a194ce8e5$var$byLigature(prefix, ligature) {
    return ($2f7ebf3a194ce8e5$var$_byLigature[prefix] || {})[ligature];
}
function $2f7ebf3a194ce8e5$var$byAlias(prefix, alias) {
    return ($2f7ebf3a194ce8e5$var$_byAlias[prefix] || {})[alias];
}
function $2f7ebf3a194ce8e5$var$byOldName(name) {
    return $2f7ebf3a194ce8e5$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
function $2f7ebf3a194ce8e5$var$byOldUnicode(unicode) {
    const oldUnicode = $2f7ebf3a194ce8e5$var$_byOldUnicode[unicode];
    const newUnicode = $2f7ebf3a194ce8e5$var$byUnicode('fas', unicode);
    return oldUnicode || (newUnicode ? {
        prefix: 'fas',
        iconName: newUnicode
    } : null) || {
        prefix: null,
        iconName: null
    };
}
function $2f7ebf3a194ce8e5$var$getDefaultUsablePrefix() {
    return $2f7ebf3a194ce8e5$var$_defaultUsablePrefix;
}
const $2f7ebf3a194ce8e5$var$emptyCanonicalIcon = ()=>{
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $2f7ebf3a194ce8e5$var$getFamilyId(values) {
    let family = $2f7ebf3a194ce8e5$var$s;
    const famProps = $2f7ebf3a194ce8e5$var$FAMILY_NAMES.reduce((acc, familyId)=>{
        acc[familyId] = "".concat($2f7ebf3a194ce8e5$var$config.cssPrefix, "-").concat(familyId);
        return acc;
    }, {});
    $2f7ebf3a194ce8e5$var$L.forEach((familyId)=>{
        if (values.includes(famProps[familyId]) || values.some((v$$1)=>$2f7ebf3a194ce8e5$var$PREFIXES_FOR_FAMILY[familyId].includes(v$$1))) family = familyId;
    });
    return family;
}
function $2f7ebf3a194ce8e5$var$getCanonicalPrefix(styleOrPrefix) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { family: family = $2f7ebf3a194ce8e5$var$s } = params;
    const style = $2f7ebf3a194ce8e5$var$PREFIX_TO_STYLE[family][styleOrPrefix];
    // handles the exception of passing in only a family of 'duotone' with no style
    if (family === $2f7ebf3a194ce8e5$var$t && !styleOrPrefix) return 'fad';
    const prefix = $2f7ebf3a194ce8e5$var$STYLE_TO_PREFIX[family][styleOrPrefix] || $2f7ebf3a194ce8e5$var$STYLE_TO_PREFIX[family][style];
    const defined = styleOrPrefix in $2f7ebf3a194ce8e5$var$namespace.styles ? styleOrPrefix : null;
    const result = prefix || defined || null;
    return result;
}
function $2f7ebf3a194ce8e5$var$moveNonFaClassesToRest(classNames) {
    let rest = [];
    let iconName = null;
    classNames.forEach((cls)=>{
        const result = $2f7ebf3a194ce8e5$var$getIconName($2f7ebf3a194ce8e5$var$config.cssPrefix, cls);
        if (result) iconName = result;
        else if (cls) rest.push(cls);
    });
    return {
        iconName: iconName,
        rest: rest
    };
}
function $2f7ebf3a194ce8e5$var$sortedUniqueValues(arr) {
    return arr.sort().filter((value, index, arr)=>{
        return arr.indexOf(value) === index;
    });
}
function $2f7ebf3a194ce8e5$var$getCanonicalIcon(values) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { skipLookups: skipLookups = false } = params;
    let givenPrefix = null;
    const faCombinedClasses = $2f7ebf3a194ce8e5$var$Ia.concat($2f7ebf3a194ce8e5$var$bt$1);
    const faStyleOrFamilyClasses = $2f7ebf3a194ce8e5$var$sortedUniqueValues(values.filter((cls)=>faCombinedClasses.includes(cls)));
    const nonStyleOrFamilyClasses = $2f7ebf3a194ce8e5$var$sortedUniqueValues(values.filter((cls)=>!$2f7ebf3a194ce8e5$var$Ia.includes(cls)));
    const faStyles = faStyleOrFamilyClasses.filter((cls)=>{
        givenPrefix = cls;
        return !$2f7ebf3a194ce8e5$var$P.includes(cls);
    });
    const [styleFromValues = null] = faStyles;
    const family = $2f7ebf3a194ce8e5$var$getFamilyId(faStyleOrFamilyClasses);
    const canonical = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$moveNonFaClassesToRest(nonStyleOrFamilyClasses)), {}, {
        prefix: $2f7ebf3a194ce8e5$var$getCanonicalPrefix(styleFromValues, {
            family: family
        })
    });
    return $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, canonical), $2f7ebf3a194ce8e5$var$getDefaultCanonicalPrefix({
        values: values,
        family: family,
        styles: $2f7ebf3a194ce8e5$var$styles,
        config: $2f7ebf3a194ce8e5$var$config,
        canonical: canonical,
        givenPrefix: givenPrefix
    })), $2f7ebf3a194ce8e5$var$applyShimAndAlias(skipLookups, givenPrefix, canonical));
}
function $2f7ebf3a194ce8e5$var$applyShimAndAlias(skipLookups, givenPrefix, canonical) {
    let { prefix: prefix, iconName: iconName } = canonical;
    if (skipLookups || !prefix || !iconName) return {
        prefix: prefix,
        iconName: iconName
    };
    const shim = givenPrefix === 'fa' ? $2f7ebf3a194ce8e5$var$byOldName(iconName) : {};
    const aliasIconName = $2f7ebf3a194ce8e5$var$byAlias(prefix, iconName);
    iconName = shim.iconName || aliasIconName || iconName;
    prefix = shim.prefix || prefix;
    if (prefix === 'far' && !$2f7ebf3a194ce8e5$var$styles['far'] && $2f7ebf3a194ce8e5$var$styles['fas'] && !$2f7ebf3a194ce8e5$var$config.autoFetchSvg) // Allow a fallback from the regular style to solid if regular is not available
    // but only if we aren't auto-fetching SVGs
    prefix = 'fas';
    return {
        prefix: prefix,
        iconName: iconName
    };
}
const $2f7ebf3a194ce8e5$var$newCanonicalFamilies = $2f7ebf3a194ce8e5$var$L.filter((familyId)=>{
    return familyId !== $2f7ebf3a194ce8e5$var$s || familyId !== $2f7ebf3a194ce8e5$var$t;
});
const $2f7ebf3a194ce8e5$var$newCanonicalStyles = Object.keys($2f7ebf3a194ce8e5$var$ga).filter((key)=>key !== $2f7ebf3a194ce8e5$var$s).map((key)=>Object.keys($2f7ebf3a194ce8e5$var$ga[key])).flat();
function $2f7ebf3a194ce8e5$var$getDefaultCanonicalPrefix(prefixOptions) {
    const { values: values, family: family, canonical: canonical, givenPrefix: givenPrefix = '', styles: styles = {}, config: config$$1 = {} } = prefixOptions;
    const isDuotoneFamily = family === $2f7ebf3a194ce8e5$var$t;
    const valuesHasDuotone = values.includes('fa-duotone') || values.includes('fad');
    const defaultFamilyIsDuotone = config$$1.familyDefault === 'duotone';
    const canonicalPrefixIsDuotone = canonical.prefix === 'fad' || canonical.prefix === 'fa-duotone';
    if (!isDuotoneFamily && (valuesHasDuotone || defaultFamilyIsDuotone || canonicalPrefixIsDuotone)) canonical.prefix = 'fad';
    if (values.includes('fa-brands') || values.includes('fab')) canonical.prefix = 'fab';
    if (!canonical.prefix && $2f7ebf3a194ce8e5$var$newCanonicalFamilies.includes(family)) {
        const validPrefix = Object.keys(styles).find((key)=>$2f7ebf3a194ce8e5$var$newCanonicalStyles.includes(key));
        if (validPrefix || config$$1.autoFetchSvg) {
            const defaultPrefix = $2f7ebf3a194ce8e5$var$pt.get(family).defaultShortPrefixId;
            canonical.prefix = defaultPrefix;
            canonical.iconName = $2f7ebf3a194ce8e5$var$byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
        }
    }
    if (canonical.prefix === 'fa' || givenPrefix === 'fa') // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = $2f7ebf3a194ce8e5$var$getDefaultUsablePrefix() || 'fas';
    return canonical;
}
class $2f7ebf3a194ce8e5$var$Library {
    constructor(){
        this.definitions = {};
    }
    add() {
        for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
        const additions = definitions.reduce(this._pullDefinitions, {});
        Object.keys(additions).forEach((key)=>{
            this.definitions[key] = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, this.definitions[key] || {}), additions[key]);
            $2f7ebf3a194ce8e5$var$defineIcons(key, additions[key]);
            // TODO can we stop doing this? We can't get the icons by 'fa-solid' any longer so this probably needs to change
            const longPrefix = $2f7ebf3a194ce8e5$var$PREFIX_TO_LONG_STYLE[$2f7ebf3a194ce8e5$var$s][key];
            if (longPrefix) $2f7ebf3a194ce8e5$var$defineIcons(longPrefix, additions[key]);
            $2f7ebf3a194ce8e5$var$build();
        });
    }
    reset() {
        this.definitions = {};
    }
    _pullDefinitions(additions, definition) {
        const normalized = definition.prefix && definition.iconName && definition.icon ? {
            0: definition
        } : definition;
        Object.keys(normalized).map((key)=>{
            const { prefix: prefix, iconName: iconName, icon: icon } = normalized[key];
            const aliases = icon[2];
            if (!additions[prefix]) additions[prefix] = {};
            if (aliases.length > 0) aliases.forEach((alias)=>{
                if (typeof alias === 'string') additions[prefix][alias] = icon;
            });
            additions[prefix][iconName] = icon;
        });
        return additions;
    }
}
let $2f7ebf3a194ce8e5$var$_plugins = [];
let $2f7ebf3a194ce8e5$var$_hooks = {};
const $2f7ebf3a194ce8e5$var$providers = {};
const $2f7ebf3a194ce8e5$var$defaultProviderKeys = Object.keys($2f7ebf3a194ce8e5$var$providers);
function $2f7ebf3a194ce8e5$var$registerPlugins(nextPlugins, _ref) {
    let { mixoutsTo: obj } = _ref;
    $2f7ebf3a194ce8e5$var$_plugins = nextPlugins;
    $2f7ebf3a194ce8e5$var$_hooks = {};
    Object.keys($2f7ebf3a194ce8e5$var$providers).forEach((k)=>{
        if ($2f7ebf3a194ce8e5$var$defaultProviderKeys.indexOf(k) === -1) delete $2f7ebf3a194ce8e5$var$providers[k];
    });
    $2f7ebf3a194ce8e5$var$_plugins.forEach((plugin)=>{
        const mixout = plugin.mixout ? plugin.mixout() : {};
        Object.keys(mixout).forEach((tk)=>{
            if (typeof mixout[tk] === 'function') obj[tk] = mixout[tk];
            if (typeof mixout[tk] === 'object') Object.keys(mixout[tk]).forEach((sk)=>{
                if (!obj[tk]) obj[tk] = {};
                obj[tk][sk] = mixout[tk][sk];
            });
        });
        if (plugin.hooks) {
            const hooks = plugin.hooks();
            Object.keys(hooks).forEach((hook)=>{
                if (!$2f7ebf3a194ce8e5$var$_hooks[hook]) $2f7ebf3a194ce8e5$var$_hooks[hook] = [];
                $2f7ebf3a194ce8e5$var$_hooks[hook].push(hooks[hook]);
            });
        }
        if (plugin.provides) plugin.provides($2f7ebf3a194ce8e5$var$providers);
    });
    return obj;
}
function $2f7ebf3a194ce8e5$var$chainHooks(hook, accumulator) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    const hookFns = $2f7ebf3a194ce8e5$var$_hooks[hook] || [];
    hookFns.forEach((hookFn)=>{
        accumulator = hookFn.apply(null, [
            accumulator,
            ...args
        ]); // eslint-disable-line no-useless-call
    });
    return accumulator;
}
function $2f7ebf3a194ce8e5$var$callHooks(hook) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    const hookFns = $2f7ebf3a194ce8e5$var$_hooks[hook] || [];
    hookFns.forEach((hookFn)=>{
        hookFn.apply(null, args);
    });
    return undefined;
}
function $2f7ebf3a194ce8e5$var$callProvided() {
    const hook = arguments[0];
    const args = Array.prototype.slice.call(arguments, 1);
    return $2f7ebf3a194ce8e5$var$providers[hook] ? $2f7ebf3a194ce8e5$var$providers[hook].apply(null, args) : undefined;
}
function $2f7ebf3a194ce8e5$var$findIconDefinition(iconLookup) {
    if (iconLookup.prefix === 'fa') iconLookup.prefix = 'fas';
    let { iconName: iconName } = iconLookup;
    const prefix = iconLookup.prefix || $2f7ebf3a194ce8e5$var$getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = $2f7ebf3a194ce8e5$var$byAlias(prefix, iconName) || iconName;
    return $2f7ebf3a194ce8e5$var$iconFromMapping($2f7ebf3a194ce8e5$var$library.definitions, prefix, iconName) || $2f7ebf3a194ce8e5$var$iconFromMapping($2f7ebf3a194ce8e5$var$namespace.styles, prefix, iconName);
}
const $2f7ebf3a194ce8e5$var$library = new $2f7ebf3a194ce8e5$var$Library();
const $2f7ebf3a194ce8e5$var$noAuto = ()=>{
    $2f7ebf3a194ce8e5$var$config.autoReplaceSvg = false;
    $2f7ebf3a194ce8e5$var$config.observeMutations = false;
    $2f7ebf3a194ce8e5$var$callHooks('noAuto');
};
const $2f7ebf3a194ce8e5$var$dom = {
    i2svg: function() {
        let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($2f7ebf3a194ce8e5$var$IS_DOM) {
            $2f7ebf3a194ce8e5$var$callHooks('beforeI2svg', params);
            $2f7ebf3a194ce8e5$var$callProvided('pseudoElements2svg', params);
            return $2f7ebf3a194ce8e5$var$callProvided('i2svg', params);
        } else return Promise.reject(new Error('Operation requires a DOM of some kind.'));
    },
    watch: function() {
        let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { autoReplaceSvgRoot: autoReplaceSvgRoot } = params;
        if ($2f7ebf3a194ce8e5$var$config.autoReplaceSvg === false) $2f7ebf3a194ce8e5$var$config.autoReplaceSvg = true;
        $2f7ebf3a194ce8e5$var$config.observeMutations = true;
        $2f7ebf3a194ce8e5$var$domready(()=>{
            $2f7ebf3a194ce8e5$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $2f7ebf3a194ce8e5$var$callHooks('watch', params);
        });
    }
};
const $2f7ebf3a194ce8e5$var$parse = {
    icon: (icon)=>{
        if (icon === null) return null;
        if (typeof icon === 'object' && icon.prefix && icon.iconName) return {
            prefix: icon.prefix,
            iconName: $2f7ebf3a194ce8e5$var$byAlias(icon.prefix, icon.iconName) || icon.iconName
        };
        if (Array.isArray(icon) && icon.length === 2) {
            const iconName = icon[1].indexOf('fa-') === 0 ? icon[1].slice(3) : icon[1];
            const prefix = $2f7ebf3a194ce8e5$var$getCanonicalPrefix(icon[0]);
            return {
                prefix: prefix,
                iconName: $2f7ebf3a194ce8e5$var$byAlias(prefix, iconName) || iconName
            };
        }
        if (typeof icon === 'string' && (icon.indexOf("".concat($2f7ebf3a194ce8e5$var$config.cssPrefix, "-")) > -1 || icon.match($2f7ebf3a194ce8e5$var$ICON_SELECTION_SYNTAX_PATTERN))) {
            const canonicalIcon = $2f7ebf3a194ce8e5$var$getCanonicalIcon(icon.split(' '), {
                skipLookups: true
            });
            return {
                prefix: canonicalIcon.prefix || $2f7ebf3a194ce8e5$var$getDefaultUsablePrefix(),
                iconName: $2f7ebf3a194ce8e5$var$byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
            };
        }
        if (typeof icon === 'string') {
            const prefix = $2f7ebf3a194ce8e5$var$getDefaultUsablePrefix();
            return {
                prefix: prefix,
                iconName: $2f7ebf3a194ce8e5$var$byAlias(prefix, icon) || icon
            };
        }
    }
};
const $2f7ebf3a194ce8e5$export$644d8ea042df96a6 = {
    noAuto: $2f7ebf3a194ce8e5$var$noAuto,
    config: $2f7ebf3a194ce8e5$var$config,
    dom: $2f7ebf3a194ce8e5$var$dom,
    parse: $2f7ebf3a194ce8e5$var$parse,
    library: $2f7ebf3a194ce8e5$var$library,
    findIconDefinition: $2f7ebf3a194ce8e5$var$findIconDefinition,
    toHtml: $2f7ebf3a194ce8e5$var$toHtml
};
const $2f7ebf3a194ce8e5$var$autoReplace = function() {
    let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const { autoReplaceSvgRoot: autoReplaceSvgRoot = $2f7ebf3a194ce8e5$var$DOCUMENT } = params;
    if ((Object.keys($2f7ebf3a194ce8e5$var$namespace.styles).length > 0 || $2f7ebf3a194ce8e5$var$config.autoFetchSvg) && $2f7ebf3a194ce8e5$var$IS_DOM && $2f7ebf3a194ce8e5$var$config.autoReplaceSvg) $2f7ebf3a194ce8e5$export$644d8ea042df96a6.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};
function $2f7ebf3a194ce8e5$var$domVariants(val, abstractCreator) {
    Object.defineProperty(val, 'abstract', {
        get: abstractCreator
    });
    Object.defineProperty(val, 'html', {
        get: function() {
            return val.abstract.map((a)=>$2f7ebf3a194ce8e5$var$toHtml(a));
        }
    });
    Object.defineProperty(val, 'node', {
        get: function() {
            if (!$2f7ebf3a194ce8e5$var$IS_DOM) return;
            const container = $2f7ebf3a194ce8e5$var$DOCUMENT.createElement('div');
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $2f7ebf3a194ce8e5$var$asIcon(_ref) {
    let { children: children, main: main, mask: mask, attributes: attributes, styles: styles, transform: transform } = _ref;
    if ($2f7ebf3a194ce8e5$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        const { width: width, height: height } = main;
        const offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes['style'] = $2f7ebf3a194ce8e5$var$joinStyles($2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, styles), {}, {
            'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: 'svg',
            attributes: attributes,
            children: children
        }
    ];
}
function $2f7ebf3a194ce8e5$var$asSymbol(_ref) {
    let { prefix: prefix, iconName: iconName, children: children, attributes: attributes, symbol: symbol } = _ref;
    const id = symbol === true ? "".concat(prefix, "-").concat($2f7ebf3a194ce8e5$var$config.cssPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: 'svg',
            attributes: {
                style: 'display: none;'
            },
            children: [
                {
                    tag: 'symbol',
                    attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, attributes), {}, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
function $2f7ebf3a194ce8e5$var$makeInlineSvgAbstract(params) {
    const { icons: { main: main, mask: mask }, prefix: prefix, iconName: iconName, transform: transform, symbol: symbol, title: title, maskId: maskId, titleId: titleId, extra: extra, watchable: watchable = false } = params;
    const { width: width, height: height } = mask.found ? mask : main;
    const isUploadedIcon = $2f7ebf3a194ce8e5$var$Lt.includes(prefix);
    const attrClass = [
        $2f7ebf3a194ce8e5$var$config.replacementClass,
        iconName ? "".concat($2f7ebf3a194ce8e5$var$config.cssPrefix, "-").concat(iconName) : ''
    ].filter((c$$1)=>extra.classes.indexOf(c$$1) === -1).filter((c$$1)=>c$$1 !== '' || !!c$$1).concat(extra.classes).join(' ');
    let content = {
        children: [],
        attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, extra.attributes), {}, {
            'data-prefix': prefix,
            'data-icon': iconName,
            'class': attrClass,
            'role': extra.attributes.role || 'img',
            'xmlns': 'http://www.w3.org/2000/svg',
            'viewBox': "0 0 ".concat(width, " ").concat(height)
        })
    };
    const uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
        width: "".concat(width / height * 1, "em")
    } : {};
    if (watchable) content.attributes[$2f7ebf3a194ce8e5$var$DATA_FA_I2SVG] = '';
    if (title) {
        content.children.push({
            tag: 'title',
            attributes: {
                id: content.attributes['aria-labelledby'] || "title-".concat(titleId || $2f7ebf3a194ce8e5$var$nextUniqueId())
            },
            children: [
                title
            ]
        });
        delete content.attributes.title;
    }
    const args = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, content), {}, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
    });
    const { children: children, attributes: attributes } = mask.found && main.found ? $2f7ebf3a194ce8e5$var$callProvided('generateAbstractMask', args) || {
        children: [],
        attributes: {}
    } : $2f7ebf3a194ce8e5$var$callProvided('generateAbstractIcon', args) || {
        children: [],
        attributes: {}
    };
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $2f7ebf3a194ce8e5$var$asSymbol(args);
    else return $2f7ebf3a194ce8e5$var$asIcon(args);
}
function $2f7ebf3a194ce8e5$var$makeLayersTextAbstract(params) {
    const { content: content, width: width, height: height, transform: transform, title: title, extra: extra, watchable: watchable = false } = params;
    const attributes = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, extra.attributes), title ? {
        'title': title
    } : {}), {}, {
        'class': extra.classes.join(' ')
    });
    if (watchable) attributes[$2f7ebf3a194ce8e5$var$DATA_FA_I2SVG] = '';
    const styles = $2f7ebf3a194ce8e5$var$_objectSpread2({}, extra.styles);
    if ($2f7ebf3a194ce8e5$var$transformIsMeaningful(transform)) {
        styles['transform'] = $2f7ebf3a194ce8e5$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles['-webkit-transform'] = styles['transform'];
    }
    const styleString = $2f7ebf3a194ce8e5$var$joinStyles(styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    const val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: 'span',
        attributes: {
            class: 'sr-only'
        },
        children: [
            title
        ]
    });
    return val;
}
function $2f7ebf3a194ce8e5$var$makeLayersCounterAbstract(params) {
    const { content: content, title: title, extra: extra } = params;
    const attributes = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, extra.attributes), title ? {
        'title': title
    } : {}), {}, {
        'class': extra.classes.join(' ')
    });
    const styleString = $2f7ebf3a194ce8e5$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    const val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: 'span',
        attributes: {
            class: 'sr-only'
        },
        children: [
            title
        ]
    });
    return val;
}
const { styles: $2f7ebf3a194ce8e5$var$styles$1 } = $2f7ebf3a194ce8e5$var$namespace;
function $2f7ebf3a194ce8e5$var$asFoundIcon(icon) {
    const width = icon[0];
    const height = icon[1];
    const [vectorData] = icon.slice(4);
    let element = null;
    if (Array.isArray(vectorData)) element = {
        tag: 'g',
        attributes: {
            class: "".concat($2f7ebf3a194ce8e5$var$config.cssPrefix, "-").concat($2f7ebf3a194ce8e5$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: 'path',
                attributes: {
                    class: "".concat($2f7ebf3a194ce8e5$var$config.cssPrefix, "-").concat($2f7ebf3a194ce8e5$var$DUOTONE_CLASSES.SECONDARY),
                    fill: 'currentColor',
                    d: vectorData[0]
                }
            },
            {
                tag: 'path',
                attributes: {
                    class: "".concat($2f7ebf3a194ce8e5$var$config.cssPrefix, "-").concat($2f7ebf3a194ce8e5$var$DUOTONE_CLASSES.PRIMARY),
                    fill: 'currentColor',
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: 'path',
        attributes: {
            fill: 'currentColor',
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
const $2f7ebf3a194ce8e5$var$missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
};
function $2f7ebf3a194ce8e5$var$maybeNotifyMissing(iconName, prefix) {
    if (!$2f7ebf3a194ce8e5$var$PRODUCTION && !$2f7ebf3a194ce8e5$var$config.showMissingIcons && iconName) console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
}
function $2f7ebf3a194ce8e5$var$findIcon(iconName, prefix) {
    let givenPrefix = prefix;
    if (prefix === 'fa' && $2f7ebf3a194ce8e5$var$config.styleDefault !== null) prefix = $2f7ebf3a194ce8e5$var$getDefaultUsablePrefix();
    return new Promise((resolve, reject)=>{
        if (givenPrefix === 'fa') {
            const shim = $2f7ebf3a194ce8e5$var$byOldName(iconName) || {};
            iconName = shim.iconName || iconName;
            prefix = shim.prefix || prefix;
        }
        if (iconName && prefix && $2f7ebf3a194ce8e5$var$styles$1[prefix] && $2f7ebf3a194ce8e5$var$styles$1[prefix][iconName]) {
            const icon = $2f7ebf3a194ce8e5$var$styles$1[prefix][iconName];
            return resolve($2f7ebf3a194ce8e5$var$asFoundIcon(icon));
        }
        $2f7ebf3a194ce8e5$var$maybeNotifyMissing(iconName, prefix);
        resolve($2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$missingIconResolutionMixin), {}, {
            icon: $2f7ebf3a194ce8e5$var$config.showMissingIcons && iconName ? $2f7ebf3a194ce8e5$var$callProvided('missingIconAbstract') || {} : {}
        }));
    });
}
const $2f7ebf3a194ce8e5$var$noop$1 = ()=>{};
const $2f7ebf3a194ce8e5$var$p$2 = $2f7ebf3a194ce8e5$var$config.measurePerformance && $2f7ebf3a194ce8e5$var$PERFORMANCE && $2f7ebf3a194ce8e5$var$PERFORMANCE.mark && $2f7ebf3a194ce8e5$var$PERFORMANCE.measure ? $2f7ebf3a194ce8e5$var$PERFORMANCE : {
    mark: $2f7ebf3a194ce8e5$var$noop$1,
    measure: $2f7ebf3a194ce8e5$var$noop$1
};
const $2f7ebf3a194ce8e5$var$preamble = "FA \"6.7.2\"";
const $2f7ebf3a194ce8e5$var$begin = (name)=>{
    $2f7ebf3a194ce8e5$var$p$2.mark("".concat($2f7ebf3a194ce8e5$var$preamble, " ").concat(name, " begins"));
    return ()=>$2f7ebf3a194ce8e5$var$end(name);
};
const $2f7ebf3a194ce8e5$var$end = (name)=>{
    $2f7ebf3a194ce8e5$var$p$2.mark("".concat($2f7ebf3a194ce8e5$var$preamble, " ").concat(name, " ends"));
    $2f7ebf3a194ce8e5$var$p$2.measure("".concat($2f7ebf3a194ce8e5$var$preamble, " ").concat(name), "".concat($2f7ebf3a194ce8e5$var$preamble, " ").concat(name, " begins"), "".concat($2f7ebf3a194ce8e5$var$preamble, " ").concat(name, " ends"));
};
var $2f7ebf3a194ce8e5$var$perf = {
    begin: $2f7ebf3a194ce8e5$var$begin,
    end: $2f7ebf3a194ce8e5$var$end
};
const $2f7ebf3a194ce8e5$var$noop$2 = ()=>{};
function $2f7ebf3a194ce8e5$var$isWatched(node) {
    const i2svg = node.getAttribute ? node.getAttribute($2f7ebf3a194ce8e5$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === 'string';
}
function $2f7ebf3a194ce8e5$var$hasPrefixAndIcon(node) {
    const prefix = node.getAttribute ? node.getAttribute($2f7ebf3a194ce8e5$var$DATA_PREFIX) : null;
    const icon = node.getAttribute ? node.getAttribute($2f7ebf3a194ce8e5$var$DATA_ICON) : null;
    return prefix && icon;
}
function $2f7ebf3a194ce8e5$var$hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains($2f7ebf3a194ce8e5$var$config.replacementClass);
}
function $2f7ebf3a194ce8e5$var$getMutator() {
    if ($2f7ebf3a194ce8e5$var$config.autoReplaceSvg === true) return $2f7ebf3a194ce8e5$var$mutators.replace;
    const mutator = $2f7ebf3a194ce8e5$var$mutators[$2f7ebf3a194ce8e5$var$config.autoReplaceSvg];
    return mutator || $2f7ebf3a194ce8e5$var$mutators.replace;
}
function $2f7ebf3a194ce8e5$var$createElementNS(tag) {
    return $2f7ebf3a194ce8e5$var$DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}
function $2f7ebf3a194ce8e5$var$createElement(tag) {
    return $2f7ebf3a194ce8e5$var$DOCUMENT.createElement(tag);
}
function $2f7ebf3a194ce8e5$var$convertSVG(abstractObj) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { ceFn: ceFn = abstractObj.tag === 'svg' ? $2f7ebf3a194ce8e5$var$createElementNS : $2f7ebf3a194ce8e5$var$createElement } = params;
    if (typeof abstractObj === 'string') return $2f7ebf3a194ce8e5$var$DOCUMENT.createTextNode(abstractObj);
    const tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function(key) {
        tag.setAttribute(key, abstractObj.attributes[key]);
    });
    const children = abstractObj.children || [];
    children.forEach(function(child) {
        tag.appendChild($2f7ebf3a194ce8e5$var$convertSVG(child, {
            ceFn: ceFn
        }));
    });
    return tag;
}
function $2f7ebf3a194ce8e5$var$nodeAsComment(node) {
    let comment = " ".concat(node.outerHTML, " ");
    /* BEGIN.ATTRIBUTION */ comment = "".concat(comment, "Font Awesome fontawesome.com ");
    /* END.ATTRIBUTION */ return comment;
}
const $2f7ebf3a194ce8e5$var$mutators = {
    replace: function(mutation) {
        const node = mutation[0];
        if (node.parentNode) {
            mutation[1].forEach((abstract)=>{
                node.parentNode.insertBefore($2f7ebf3a194ce8e5$var$convertSVG(abstract), node);
            });
            if (node.getAttribute($2f7ebf3a194ce8e5$var$DATA_FA_I2SVG) === null && $2f7ebf3a194ce8e5$var$config.keepOriginalSource) {
                let comment = $2f7ebf3a194ce8e5$var$DOCUMENT.createComment($2f7ebf3a194ce8e5$var$nodeAsComment(node));
                node.parentNode.replaceChild(comment, node);
            } else node.remove();
        }
    },
    nest: function(mutation) {
        const node = mutation[0];
        const abstract = mutation[1];
        // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$2f7ebf3a194ce8e5$var$classArray(node).indexOf($2f7ebf3a194ce8e5$var$config.replacementClass)) return $2f7ebf3a194ce8e5$var$mutators.replace(mutation);
        const forSvg = new RegExp("".concat($2f7ebf3a194ce8e5$var$config.cssPrefix, "-.*"));
        delete abstract[0].attributes.id;
        if (abstract[0].attributes.class) {
            const splitClasses = abstract[0].attributes.class.split(' ').reduce((acc, cls)=>{
                if (cls === $2f7ebf3a194ce8e5$var$config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            abstract[0].attributes.class = splitClasses.toSvg.join(' ');
            if (splitClasses.toNode.length === 0) node.removeAttribute('class');
            else node.setAttribute('class', splitClasses.toNode.join(' '));
        }
        const newInnerHTML = abstract.map((a)=>$2f7ebf3a194ce8e5$var$toHtml(a)).join('\n');
        node.setAttribute($2f7ebf3a194ce8e5$var$DATA_FA_I2SVG, '');
        node.innerHTML = newInnerHTML;
    }
};
function $2f7ebf3a194ce8e5$var$performOperationSync(op) {
    op();
}
function $2f7ebf3a194ce8e5$var$perform(mutations, callback) {
    const callbackFunction = typeof callback === 'function' ? callback : $2f7ebf3a194ce8e5$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        let frame = $2f7ebf3a194ce8e5$var$performOperationSync;
        if ($2f7ebf3a194ce8e5$var$config.mutateApproach === $2f7ebf3a194ce8e5$var$MUTATION_APPROACH_ASYNC) frame = $2f7ebf3a194ce8e5$var$WINDOW.requestAnimationFrame || $2f7ebf3a194ce8e5$var$performOperationSync;
        frame(()=>{
            const mutator = $2f7ebf3a194ce8e5$var$getMutator();
            const mark = $2f7ebf3a194ce8e5$var$perf.begin('mutate');
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
let $2f7ebf3a194ce8e5$var$disabled = false;
function $2f7ebf3a194ce8e5$var$disableObservation() {
    $2f7ebf3a194ce8e5$var$disabled = true;
}
function $2f7ebf3a194ce8e5$var$enableObservation() {
    $2f7ebf3a194ce8e5$var$disabled = false;
}
let $2f7ebf3a194ce8e5$var$mo = null;
function $2f7ebf3a194ce8e5$var$observe(options) {
    if (!$2f7ebf3a194ce8e5$var$MUTATION_OBSERVER) return;
    if (!$2f7ebf3a194ce8e5$var$config.observeMutations) return;
    const { treeCallback: treeCallback = $2f7ebf3a194ce8e5$var$noop$2, nodeCallback: nodeCallback = $2f7ebf3a194ce8e5$var$noop$2, pseudoElementsCallback: pseudoElementsCallback = $2f7ebf3a194ce8e5$var$noop$2, observeMutationsRoot: observeMutationsRoot = $2f7ebf3a194ce8e5$var$DOCUMENT } = options;
    $2f7ebf3a194ce8e5$var$mo = new $2f7ebf3a194ce8e5$var$MUTATION_OBSERVER((objects)=>{
        if ($2f7ebf3a194ce8e5$var$disabled) return;
        const defaultPrefix = $2f7ebf3a194ce8e5$var$getDefaultUsablePrefix();
        $2f7ebf3a194ce8e5$var$toArray(objects).forEach((mutationRecord)=>{
            if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !$2f7ebf3a194ce8e5$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($2f7ebf3a194ce8e5$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && $2f7ebf3a194ce8e5$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
            if (mutationRecord.type === 'attributes' && $2f7ebf3a194ce8e5$var$isWatched(mutationRecord.target) && ~$2f7ebf3a194ce8e5$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === 'class' && $2f7ebf3a194ce8e5$var$hasPrefixAndIcon(mutationRecord.target)) {
                    const { prefix: prefix, iconName: iconName } = $2f7ebf3a194ce8e5$var$getCanonicalIcon($2f7ebf3a194ce8e5$var$classArray(mutationRecord.target));
                    mutationRecord.target.setAttribute($2f7ebf3a194ce8e5$var$DATA_PREFIX, prefix || defaultPrefix);
                    if (iconName) mutationRecord.target.setAttribute($2f7ebf3a194ce8e5$var$DATA_ICON, iconName);
                } else if ($2f7ebf3a194ce8e5$var$hasBeenReplaced(mutationRecord.target)) nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$2f7ebf3a194ce8e5$var$IS_DOM) return;
    $2f7ebf3a194ce8e5$var$mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $2f7ebf3a194ce8e5$var$disconnect() {
    if (!$2f7ebf3a194ce8e5$var$mo) return;
    $2f7ebf3a194ce8e5$var$mo.disconnect();
}
function $2f7ebf3a194ce8e5$var$styleParser(node) {
    const style = node.getAttribute('style');
    let val = [];
    if (style) val = style.split(';').reduce((acc, style)=>{
        const styles = style.split(':');
        const prop = styles[0];
        const value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(':').trim();
        return acc;
    }, {});
    return val;
}
function $2f7ebf3a194ce8e5$var$classParser(node) {
    const existingPrefix = node.getAttribute('data-prefix');
    const existingIconName = node.getAttribute('data-icon');
    const innerText = node.innerText !== undefined ? node.innerText.trim() : '';
    let val = $2f7ebf3a194ce8e5$var$getCanonicalIcon($2f7ebf3a194ce8e5$var$classArray(node));
    if (!val.prefix) val.prefix = $2f7ebf3a194ce8e5$var$getDefaultUsablePrefix();
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.iconName && val.prefix) return val;
    if (val.prefix && innerText.length > 0) val.iconName = $2f7ebf3a194ce8e5$var$byLigature(val.prefix, node.innerText) || $2f7ebf3a194ce8e5$var$byUnicode(val.prefix, $2f7ebf3a194ce8e5$var$toHex(node.innerText));
    if (!val.iconName && $2f7ebf3a194ce8e5$var$config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) val.iconName = node.firstChild.data;
    return val;
}
function $2f7ebf3a194ce8e5$var$attributesParser(node) {
    const extraAttributes = $2f7ebf3a194ce8e5$var$toArray(node.attributes).reduce((acc, attr)=>{
        if (acc.name !== 'class' && acc.name !== 'style') acc[attr.name] = attr.value;
        return acc;
    }, {});
    const title = node.getAttribute('title');
    const titleId = node.getAttribute('data-fa-title-id');
    if ($2f7ebf3a194ce8e5$var$config.autoA11y) {
        if (title) extraAttributes['aria-labelledby'] = "".concat($2f7ebf3a194ce8e5$var$config.replacementClass, "-title-").concat(titleId || $2f7ebf3a194ce8e5$var$nextUniqueId());
        else {
            extraAttributes['aria-hidden'] = 'true';
            extraAttributes['focusable'] = 'false';
        }
    }
    return extraAttributes;
}
function $2f7ebf3a194ce8e5$var$blankMeta() {
    return {
        iconName: null,
        title: null,
        titleId: null,
        prefix: null,
        transform: $2f7ebf3a194ce8e5$var$meaninglessTransform,
        symbol: false,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $2f7ebf3a194ce8e5$var$parseMeta(node) {
    let parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        styleParser: true
    };
    const { iconName: iconName, prefix: prefix, rest: extraClasses } = $2f7ebf3a194ce8e5$var$classParser(node);
    const extraAttributes = $2f7ebf3a194ce8e5$var$attributesParser(node);
    const pluginMeta = $2f7ebf3a194ce8e5$var$chainHooks('parseNodeAttributes', {}, node);
    let extraStyles = parser.styleParser ? $2f7ebf3a194ce8e5$var$styleParser(node) : [];
    return $2f7ebf3a194ce8e5$var$_objectSpread2({
        iconName: iconName,
        title: node.getAttribute('title'),
        titleId: node.getAttribute('data-fa-title-id'),
        prefix: prefix,
        transform: $2f7ebf3a194ce8e5$var$meaninglessTransform,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: false,
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    }, pluginMeta);
}
const { styles: $2f7ebf3a194ce8e5$var$styles$2 } = $2f7ebf3a194ce8e5$var$namespace;
function $2f7ebf3a194ce8e5$var$generateMutation(node) {
    const nodeMeta = $2f7ebf3a194ce8e5$var$config.autoReplaceSvg === 'nest' ? $2f7ebf3a194ce8e5$var$parseMeta(node, {
        styleParser: false
    }) : $2f7ebf3a194ce8e5$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($2f7ebf3a194ce8e5$var$LAYERS_TEXT_CLASSNAME)) return $2f7ebf3a194ce8e5$var$callProvided('generateLayersText', node, nodeMeta);
    else return $2f7ebf3a194ce8e5$var$callProvided('generateSvgReplacementMutation', node, nodeMeta);
}
function $2f7ebf3a194ce8e5$var$getKnownPrefixes() {
    return [
        ...$2f7ebf3a194ce8e5$var$Ft,
        ...$2f7ebf3a194ce8e5$var$Ia
    ];
}
function $2f7ebf3a194ce8e5$var$onTree(root) {
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$2f7ebf3a194ce8e5$var$IS_DOM) return Promise.resolve();
    const htmlClassList = $2f7ebf3a194ce8e5$var$DOCUMENT.documentElement.classList;
    const hclAdd = (suffix)=>htmlClassList.add("".concat($2f7ebf3a194ce8e5$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    const hclRemove = (suffix)=>htmlClassList.remove("".concat($2f7ebf3a194ce8e5$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    const prefixes = $2f7ebf3a194ce8e5$var$config.autoFetchSvg ? $2f7ebf3a194ce8e5$var$getKnownPrefixes() : $2f7ebf3a194ce8e5$var$P.concat(Object.keys($2f7ebf3a194ce8e5$var$styles$2));
    if (!prefixes.includes('fa')) prefixes.push('fa');
    const prefixesDomQuery = [
        ".".concat($2f7ebf3a194ce8e5$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($2f7ebf3a194ce8e5$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map((p$$1)=>".".concat(p$$1, ":not([").concat($2f7ebf3a194ce8e5$var$DATA_FA_I2SVG, "])"))).join(', ');
    if (prefixesDomQuery.length === 0) return Promise.resolve();
    let candidates = [];
    try {
        candidates = $2f7ebf3a194ce8e5$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e$$1) {
    // noop
    }
    if (candidates.length > 0) {
        hclAdd('pending');
        hclRemove('complete');
    } else return Promise.resolve();
    const mark = $2f7ebf3a194ce8e5$var$perf.begin('onTree');
    const mutations = candidates.reduce((acc, node)=>{
        try {
            const mutation = $2f7ebf3a194ce8e5$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e$$1) {
            if (!$2f7ebf3a194ce8e5$var$PRODUCTION) {
                if (e$$1.name === 'MissingIcon') console.error(e$$1);
            }
        }
        return acc;
    }, []);
    return new Promise((resolve, reject)=>{
        Promise.all(mutations).then((resolvedMutations)=>{
            $2f7ebf3a194ce8e5$var$perform(resolvedMutations, ()=>{
                hclAdd('active');
                hclAdd('complete');
                hclRemove('pending');
                if (typeof callback === 'function') callback();
                mark();
                resolve();
            });
        }).catch((e$$1)=>{
            mark();
            reject(e$$1);
        });
    });
}
function $2f7ebf3a194ce8e5$var$onNode(node) {
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $2f7ebf3a194ce8e5$var$generateMutation(node).then((mutation)=>{
        if (mutation) $2f7ebf3a194ce8e5$var$perform([
            mutation
        ], callback);
    });
}
function $2f7ebf3a194ce8e5$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $2f7ebf3a194ce8e5$var$findIconDefinition(maybeIconDefinition || {});
        let { mask: mask } = params;
        if (mask) mask = (mask || {}).icon ? mask : $2f7ebf3a194ce8e5$var$findIconDefinition(mask || {});
        return next(iconDefinition, $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, params), {}, {
            mask: mask
        }));
    };
}
const $2f7ebf3a194ce8e5$var$render = function(iconDefinition) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { transform: transform = $2f7ebf3a194ce8e5$var$meaninglessTransform, symbol: symbol = false, mask: mask = null, maskId: maskId = null, title: title = null, titleId: titleId = null, classes: classes = [], attributes: attributes = {}, styles: styles = {} } = params;
    if (!iconDefinition) return;
    const { prefix: prefix, iconName: iconName, icon: icon } = iconDefinition;
    return $2f7ebf3a194ce8e5$var$domVariants($2f7ebf3a194ce8e5$var$_objectSpread2({
        type: 'icon'
    }, iconDefinition), ()=>{
        $2f7ebf3a194ce8e5$var$callHooks('beforeDOMElementCreation', {
            iconDefinition: iconDefinition,
            params: params
        });
        if ($2f7ebf3a194ce8e5$var$config.autoA11y) {
            if (title) attributes['aria-labelledby'] = "".concat($2f7ebf3a194ce8e5$var$config.replacementClass, "-title-").concat(titleId || $2f7ebf3a194ce8e5$var$nextUniqueId());
            else {
                attributes['aria-hidden'] = 'true';
                attributes['focusable'] = 'false';
            }
        }
        return $2f7ebf3a194ce8e5$var$makeInlineSvgAbstract({
            icons: {
                main: $2f7ebf3a194ce8e5$var$asFoundIcon(icon),
                mask: mask ? $2f7ebf3a194ce8e5$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$meaninglessTransform), transform),
            symbol: symbol,
            title: title,
            maskId: maskId,
            titleId: titleId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
};
var $2f7ebf3a194ce8e5$var$ReplaceElements = {
    mixout () {
        return {
            icon: $2f7ebf3a194ce8e5$var$resolveIcons($2f7ebf3a194ce8e5$var$render)
        };
    },
    hooks () {
        return {
            mutationObserverCallbacks (accumulator) {
                accumulator.treeCallback = $2f7ebf3a194ce8e5$var$onTree;
                accumulator.nodeCallback = $2f7ebf3a194ce8e5$var$onNode;
                return accumulator;
            }
        };
    },
    provides (providers$$1) {
        providers$$1.i2svg = function(params) {
            const { node: node = $2f7ebf3a194ce8e5$var$DOCUMENT, callback: callback = ()=>{} } = params;
            return $2f7ebf3a194ce8e5$var$onTree(node, callback);
        };
        providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
            const { iconName: iconName, title: title, titleId: titleId, prefix: prefix, transform: transform, symbol: symbol, mask: mask, maskId: maskId, extra: extra } = nodeMeta;
            return new Promise((resolve, reject)=>{
                Promise.all([
                    $2f7ebf3a194ce8e5$var$findIcon(iconName, prefix),
                    mask.iconName ? $2f7ebf3a194ce8e5$var$findIcon(mask.iconName, mask.prefix) : Promise.resolve({
                        found: false,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then((_ref)=>{
                    let [main, mask] = _ref;
                    resolve([
                        node,
                        $2f7ebf3a194ce8e5$var$makeInlineSvgAbstract({
                            icons: {
                                main: main,
                                mask: mask
                            },
                            prefix: prefix,
                            iconName: iconName,
                            transform: transform,
                            symbol: symbol,
                            maskId: maskId,
                            title: title,
                            titleId: titleId,
                            extra: extra,
                            watchable: true
                        })
                    ]);
                }).catch(reject);
            });
        };
        providers$$1.generateAbstractIcon = function(_ref2) {
            let { children: children, attributes: attributes, main: main, transform: transform, styles: styles } = _ref2;
            const styleString = $2f7ebf3a194ce8e5$var$joinStyles(styles);
            if (styleString.length > 0) attributes['style'] = styleString;
            let nextChild;
            if ($2f7ebf3a194ce8e5$var$transformIsMeaningful(transform)) nextChild = $2f7ebf3a194ce8e5$var$callProvided('generateAbstractTransformGrouping', {
                main: main,
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push(nextChild || main.icon);
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $2f7ebf3a194ce8e5$var$Layers = {
    mixout () {
        return {
            layer (assembler) {
                let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                const { classes: classes = [] } = params;
                return $2f7ebf3a194ce8e5$var$domVariants({
                    type: 'layer'
                }, ()=>{
                    $2f7ebf3a194ce8e5$var$callHooks('beforeDOMElementCreation', {
                        assembler: assembler,
                        params: params
                    });
                    let children = [];
                    assembler((args)=>{
                        Array.isArray(args) ? args.map((a)=>{
                            children = children.concat(a.abstract);
                        }) : children = children.concat(args.abstract);
                    });
                    return [
                        {
                            tag: 'span',
                            attributes: {
                                class: [
                                    "".concat($2f7ebf3a194ce8e5$var$config.cssPrefix, "-layers"),
                                    ...classes
                                ].join(' ')
                            },
                            children: children
                        }
                    ];
                });
            }
        };
    }
};
var $2f7ebf3a194ce8e5$var$LayersCounter = {
    mixout () {
        return {
            counter (content) {
                let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                const { title: title = null, classes: classes = [], attributes: attributes = {}, styles: styles = {} } = params;
                return $2f7ebf3a194ce8e5$var$domVariants({
                    type: 'counter',
                    content: content
                }, ()=>{
                    $2f7ebf3a194ce8e5$var$callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return $2f7ebf3a194ce8e5$var$makeLayersCounterAbstract({
                        content: content.toString(),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($2f7ebf3a194ce8e5$var$config.cssPrefix, "-layers-counter"),
                                ...classes
                            ]
                        }
                    });
                });
            }
        };
    }
};
var $2f7ebf3a194ce8e5$var$LayersText = {
    mixout () {
        return {
            text (content) {
                let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                const { transform: transform = $2f7ebf3a194ce8e5$var$meaninglessTransform, title: title = null, classes: classes = [], attributes: attributes = {}, styles: styles = {} } = params;
                return $2f7ebf3a194ce8e5$var$domVariants({
                    type: 'text',
                    content: content
                }, ()=>{
                    $2f7ebf3a194ce8e5$var$callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return $2f7ebf3a194ce8e5$var$makeLayersTextAbstract({
                        content: content,
                        transform: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$meaninglessTransform), transform),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($2f7ebf3a194ce8e5$var$config.cssPrefix, "-layers-text"),
                                ...classes
                            ]
                        }
                    });
                });
            }
        };
    },
    provides (providers$$1) {
        providers$$1.generateLayersText = function(node, nodeMeta) {
            const { title: title, transform: transform, extra: extra } = nodeMeta;
            let width = null;
            let height = null;
            if ($2f7ebf3a194ce8e5$var$IS_IE) {
                const computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
                const boundingClientRect = node.getBoundingClientRect();
                width = boundingClientRect.width / computedFontSize;
                height = boundingClientRect.height / computedFontSize;
            }
            if ($2f7ebf3a194ce8e5$var$config.autoA11y && !title) extra.attributes['aria-hidden'] = 'true';
            return Promise.resolve([
                node,
                $2f7ebf3a194ce8e5$var$makeLayersTextAbstract({
                    content: node.innerHTML,
                    width: width,
                    height: height,
                    transform: transform,
                    title: title,
                    extra: extra,
                    watchable: true
                })
            ]);
        };
    }
};
const $2f7ebf3a194ce8e5$var$CLEAN_CONTENT_PATTERN = new RegExp('"', 'ug');
const $2f7ebf3a194ce8e5$var$SECONDARY_UNICODE_RANGE = [
    1105920,
    1112319
];
const $2f7ebf3a194ce8e5$var$_FONT_FAMILY_WEIGHT_TO_PREFIX = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, {
    FontAwesome: {
        normal: 'fas',
        400: 'fas'
    }
}), $2f7ebf3a194ce8e5$var$lt), $2f7ebf3a194ce8e5$var$wa), $2f7ebf3a194ce8e5$var$Yt);
const $2f7ebf3a194ce8e5$var$FONT_FAMILY_WEIGHT_TO_PREFIX = Object.keys($2f7ebf3a194ce8e5$var$_FONT_FAMILY_WEIGHT_TO_PREFIX).reduce((acc, key)=>{
    acc[key.toLowerCase()] = $2f7ebf3a194ce8e5$var$_FONT_FAMILY_WEIGHT_TO_PREFIX[key];
    return acc;
}, {});
const $2f7ebf3a194ce8e5$var$FONT_FAMILY_WEIGHT_FALLBACK = Object.keys($2f7ebf3a194ce8e5$var$FONT_FAMILY_WEIGHT_TO_PREFIX).reduce((acc, fontFamily)=>{
    const weights = $2f7ebf3a194ce8e5$var$FONT_FAMILY_WEIGHT_TO_PREFIX[fontFamily];
    acc[fontFamily] = weights[900] || [
        ...Object.entries(weights)
    ][0][1];
    return acc;
}, {});
function $2f7ebf3a194ce8e5$var$hexValueFromContent(content) {
    const cleaned = content.replace($2f7ebf3a194ce8e5$var$CLEAN_CONTENT_PATTERN, '');
    const codePoint = $2f7ebf3a194ce8e5$var$codePointAt(cleaned, 0);
    const isPrependTen = codePoint >= $2f7ebf3a194ce8e5$var$SECONDARY_UNICODE_RANGE[0] && codePoint <= $2f7ebf3a194ce8e5$var$SECONDARY_UNICODE_RANGE[1];
    const isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return {
        value: isDoubled ? $2f7ebf3a194ce8e5$var$toHex(cleaned[0]) : $2f7ebf3a194ce8e5$var$toHex(cleaned),
        isSecondary: isPrependTen || isDoubled
    };
}
function $2f7ebf3a194ce8e5$var$getPrefix(fontFamily, fontWeight) {
    const fontFamilySanitized = fontFamily.replace(/^['"]|['"]$/g, '').toLowerCase();
    const fontWeightInteger = parseInt(fontWeight);
    const fontWeightSanitized = isNaN(fontWeightInteger) ? 'normal' : fontWeightInteger;
    return ($2f7ebf3a194ce8e5$var$FONT_FAMILY_WEIGHT_TO_PREFIX[fontFamilySanitized] || {})[fontWeightSanitized] || $2f7ebf3a194ce8e5$var$FONT_FAMILY_WEIGHT_FALLBACK[fontFamilySanitized];
}
function $2f7ebf3a194ce8e5$var$replaceForPosition(node, position) {
    const pendingAttribute = "".concat($2f7ebf3a194ce8e5$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
    return new Promise((resolve, reject)=>{
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        const children = $2f7ebf3a194ce8e5$var$toArray(node.children);
        const alreadyProcessedPseudoElement = children.filter((c$$1)=>c$$1.getAttribute($2f7ebf3a194ce8e5$var$DATA_FA_PSEUDO_ELEMENT) === position)[0];
        const styles = $2f7ebf3a194ce8e5$var$WINDOW.getComputedStyle(node, position);
        const fontFamily = styles.getPropertyValue('font-family');
        const fontFamilyMatch = fontFamily.match($2f7ebf3a194ce8e5$var$FONT_FAMILY_PATTERN);
        const fontWeight = styles.getPropertyValue('font-weight');
        const content = styles.getPropertyValue('content');
        if (alreadyProcessedPseudoElement && !fontFamilyMatch) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamilyMatch && content !== 'none' && content !== '') {
            const content = styles.getPropertyValue('content');
            let prefix = $2f7ebf3a194ce8e5$var$getPrefix(fontFamily, fontWeight);
            const { value: hexValue, isSecondary: isSecondary } = $2f7ebf3a194ce8e5$var$hexValueFromContent(content);
            const isV4 = fontFamilyMatch[0].startsWith('FontAwesome');
            let iconName = $2f7ebf3a194ce8e5$var$byUnicode(prefix, hexValue);
            let iconIdentifier = iconName;
            if (isV4) {
                const iconName4 = $2f7ebf3a194ce8e5$var$byOldUnicode(hexValue);
                if (iconName4.iconName && iconName4.prefix) {
                    iconName = iconName4.iconName;
                    prefix = iconName4.prefix;
                }
            }
            // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($2f7ebf3a194ce8e5$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($2f7ebf3a194ce8e5$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                const meta = $2f7ebf3a194ce8e5$var$blankMeta();
                const { extra: extra } = meta;
                extra.attributes[$2f7ebf3a194ce8e5$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $2f7ebf3a194ce8e5$var$findIcon(iconName, prefix).then((main)=>{
                    const abstract = $2f7ebf3a194ce8e5$var$makeInlineSvgAbstract($2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, meta), {}, {
                        icons: {
                            main: main,
                            mask: $2f7ebf3a194ce8e5$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    const element = $2f7ebf3a194ce8e5$var$DOCUMENT.createElementNS('http://www.w3.org/2000/svg', 'svg');
                    if (position === '::before') node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = abstract.map((a$$1)=>$2f7ebf3a194ce8e5$var$toHtml(a$$1)).join('\n');
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function $2f7ebf3a194ce8e5$var$replace(node) {
    return Promise.all([
        $2f7ebf3a194ce8e5$var$replaceForPosition(node, '::before'),
        $2f7ebf3a194ce8e5$var$replaceForPosition(node, '::after')
    ]);
}
function $2f7ebf3a194ce8e5$var$processable(node) {
    return node.parentNode !== document.head && !~$2f7ebf3a194ce8e5$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($2f7ebf3a194ce8e5$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}
function $2f7ebf3a194ce8e5$var$searchPseudoElements(root) {
    if (!$2f7ebf3a194ce8e5$var$IS_DOM) return;
    return new Promise((resolve, reject)=>{
        const operations = $2f7ebf3a194ce8e5$var$toArray(root.querySelectorAll('*')).filter($2f7ebf3a194ce8e5$var$processable).map($2f7ebf3a194ce8e5$var$replace);
        const end = $2f7ebf3a194ce8e5$var$perf.begin('searchPseudoElements');
        $2f7ebf3a194ce8e5$var$disableObservation();
        Promise.all(operations).then(()=>{
            end();
            $2f7ebf3a194ce8e5$var$enableObservation();
            resolve();
        }).catch(()=>{
            end();
            $2f7ebf3a194ce8e5$var$enableObservation();
            reject();
        });
    });
}
var $2f7ebf3a194ce8e5$var$PseudoElements = {
    hooks () {
        return {
            mutationObserverCallbacks (accumulator) {
                accumulator.pseudoElementsCallback = $2f7ebf3a194ce8e5$var$searchPseudoElements;
                return accumulator;
            }
        };
    },
    provides (providers) {
        providers.pseudoElements2svg = function(params) {
            const { node: node = $2f7ebf3a194ce8e5$var$DOCUMENT } = params;
            if ($2f7ebf3a194ce8e5$var$config.searchPseudoElements) $2f7ebf3a194ce8e5$var$searchPseudoElements(node);
        };
    }
};
let $2f7ebf3a194ce8e5$var$_unwatched = false;
var $2f7ebf3a194ce8e5$var$MutationObserver$1 = {
    mixout () {
        return {
            dom: {
                unwatch () {
                    $2f7ebf3a194ce8e5$var$disableObservation();
                    $2f7ebf3a194ce8e5$var$_unwatched = true;
                }
            }
        };
    },
    hooks () {
        return {
            bootstrap () {
                $2f7ebf3a194ce8e5$var$observe($2f7ebf3a194ce8e5$var$chainHooks('mutationObserverCallbacks', {}));
            },
            noAuto () {
                $2f7ebf3a194ce8e5$var$disconnect();
            },
            watch (params) {
                const { observeMutationsRoot: observeMutationsRoot } = params;
                if ($2f7ebf3a194ce8e5$var$_unwatched) $2f7ebf3a194ce8e5$var$enableObservation();
                else $2f7ebf3a194ce8e5$var$observe($2f7ebf3a194ce8e5$var$chainHooks('mutationObserverCallbacks', {
                    observeMutationsRoot: observeMutationsRoot
                }));
            }
        };
    }
};
const $2f7ebf3a194ce8e5$var$parseTransformString = (transformString)=>{
    let transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    return transformString.toLowerCase().split(' ').reduce((acc, n)=>{
        const parts = n.toLowerCase().split('-');
        const first = parts[0];
        let rest = parts.slice(1).join('-');
        if (first && rest === 'h') {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === 'v') {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case 'grow':
                acc.size = acc.size + rest;
                break;
            case 'shrink':
                acc.size = acc.size - rest;
                break;
            case 'left':
                acc.x = acc.x - rest;
                break;
            case 'right':
                acc.x = acc.x + rest;
                break;
            case 'up':
                acc.y = acc.y - rest;
                break;
            case 'down':
                acc.y = acc.y + rest;
                break;
            case 'rotate':
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
var $2f7ebf3a194ce8e5$var$PowerTransforms = {
    mixout () {
        return {
            parse: {
                transform: (transformString)=>{
                    return $2f7ebf3a194ce8e5$var$parseTransformString(transformString);
                }
            }
        };
    },
    hooks () {
        return {
            parseNodeAttributes (accumulator, node) {
                const transformString = node.getAttribute('data-fa-transform');
                if (transformString) accumulator.transform = $2f7ebf3a194ce8e5$var$parseTransformString(transformString);
                return accumulator;
            }
        };
    },
    provides (providers) {
        providers.generateAbstractTransformGrouping = function(_ref) {
            let { main: main, transform: transform, containerWidth: containerWidth, iconWidth: iconWidth } = _ref;
            const outer = {
                transform: "translate(".concat(containerWidth / 2, " 256)")
            };
            const innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
            const innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
            const innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
            const inner = {
                transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
            };
            const path = {
                transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
            };
            const operations = {
                outer: outer,
                inner: inner,
                path: path
            };
            return {
                tag: 'g',
                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2({}, operations.outer),
                children: [
                    {
                        tag: 'g',
                        attributes: $2f7ebf3a194ce8e5$var$_objectSpread2({}, operations.inner),
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, main.icon.attributes), operations.path)
                            }
                        ]
                    }
                ]
            };
        };
    }
};
const $2f7ebf3a194ce8e5$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: '100%',
    height: '100%'
};
function $2f7ebf3a194ce8e5$var$fillBlack(abstract) {
    let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (abstract.attributes && (abstract.attributes.fill || force)) abstract.attributes.fill = 'black';
    return abstract;
}
function $2f7ebf3a194ce8e5$var$deGroup(abstract) {
    if (abstract.tag === 'g') return abstract.children;
    else return [
        abstract
    ];
}
var $2f7ebf3a194ce8e5$var$Masks = {
    hooks () {
        return {
            parseNodeAttributes (accumulator, node) {
                const maskData = node.getAttribute('data-fa-mask');
                const mask = !maskData ? $2f7ebf3a194ce8e5$var$emptyCanonicalIcon() : $2f7ebf3a194ce8e5$var$getCanonicalIcon(maskData.split(' ').map((i)=>i.trim()));
                if (!mask.prefix) mask.prefix = $2f7ebf3a194ce8e5$var$getDefaultUsablePrefix();
                accumulator.mask = mask;
                accumulator.maskId = node.getAttribute('data-fa-mask-id');
                return accumulator;
            }
        };
    },
    provides (providers) {
        providers.generateAbstractMask = function(_ref) {
            let { children: children, attributes: attributes, main: main, mask: mask, maskId: explicitMaskId, transform: transform } = _ref;
            const { width: mainWidth, icon: mainPath } = main;
            const { width: maskWidth, icon: maskPath } = mask;
            const trans = $2f7ebf3a194ce8e5$var$transformForSvg({
                transform: transform,
                containerWidth: maskWidth,
                iconWidth: mainWidth
            });
            const maskRect = {
                tag: 'rect',
                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$ALL_SPACE), {}, {
                    fill: 'white'
                })
            };
            const maskInnerGroupChildrenMixin = mainPath.children ? {
                children: mainPath.children.map($2f7ebf3a194ce8e5$var$fillBlack)
            } : {};
            const maskInnerGroup = {
                tag: 'g',
                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2({}, trans.inner),
                children: [
                    $2f7ebf3a194ce8e5$var$fillBlack($2f7ebf3a194ce8e5$var$_objectSpread2({
                        tag: mainPath.tag,
                        attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, mainPath.attributes), trans.path)
                    }, maskInnerGroupChildrenMixin))
                ]
            };
            const maskOuterGroup = {
                tag: 'g',
                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2({}, trans.outer),
                children: [
                    maskInnerGroup
                ]
            };
            const maskId = "mask-".concat(explicitMaskId || $2f7ebf3a194ce8e5$var$nextUniqueId());
            const clipId = "clip-".concat(explicitMaskId || $2f7ebf3a194ce8e5$var$nextUniqueId());
            const maskTag = {
                tag: 'mask',
                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, $2f7ebf3a194ce8e5$var$ALL_SPACE), {}, {
                    id: maskId,
                    maskUnits: 'userSpaceOnUse',
                    maskContentUnits: 'userSpaceOnUse'
                }),
                children: [
                    maskRect,
                    maskOuterGroup
                ]
            };
            const defs = {
                tag: 'defs',
                children: [
                    {
                        tag: 'clipPath',
                        attributes: {
                            id: clipId
                        },
                        children: $2f7ebf3a194ce8e5$var$deGroup(maskPath)
                    },
                    maskTag
                ]
            };
            children.push(defs, {
                tag: 'rect',
                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2({
                    fill: 'currentColor',
                    'clip-path': "url(#".concat(clipId, ")"),
                    mask: "url(#".concat(maskId, ")")
                }, $2f7ebf3a194ce8e5$var$ALL_SPACE)
            });
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $2f7ebf3a194ce8e5$var$MissingIconIndicator = {
    provides (providers) {
        let reduceMotion = false;
        if ($2f7ebf3a194ce8e5$var$WINDOW.matchMedia) reduceMotion = $2f7ebf3a194ce8e5$var$WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
        providers.missingIconAbstract = function() {
            const gChildren = [];
            const FILL = {
                fill: 'currentColor'
            };
            const ANIMATION_BASE = {
                attributeType: 'XML',
                repeatCount: 'indefinite',
                dur: '2s'
            };
            // Ring
            gChildren.push({
                tag: 'path',
                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, FILL), {}, {
                    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
                })
            });
            const OPACITY_ANIMATE = $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                attributeName: 'opacity'
            });
            const dot = {
                tag: 'circle',
                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, FILL), {}, {
                    cx: '256',
                    cy: '364',
                    r: '28'
                }),
                children: []
            };
            if (!reduceMotion) dot.children.push({
                tag: 'animate',
                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                    attributeName: 'r',
                    values: '28;14;28;28;14;28;'
                })
            }, {
                tag: 'animate',
                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                    values: '1;0;1;1;0;1;'
                })
            });
            gChildren.push(dot);
            gChildren.push({
                tag: 'path',
                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, FILL), {}, {
                    opacity: '1',
                    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
                }),
                children: reduceMotion ? [] : [
                    {
                        tag: 'animate',
                        attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '1;0;0;0;0;1;'
                        })
                    }
                ]
            });
            if (!reduceMotion) // Exclamation
            gChildren.push({
                tag: 'path',
                attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, FILL), {}, {
                    opacity: '0',
                    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
                }),
                children: [
                    {
                        tag: 'animate',
                        attributes: $2f7ebf3a194ce8e5$var$_objectSpread2($2f7ebf3a194ce8e5$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '0;0;1;1;0;0;'
                        })
                    }
                ]
            });
            return {
                tag: 'g',
                attributes: {
                    'class': 'missing'
                },
                children: gChildren
            };
        };
    }
};
var $2f7ebf3a194ce8e5$var$SvgSymbols = {
    hooks () {
        return {
            parseNodeAttributes (accumulator, node) {
                const symbolData = node.getAttribute('data-fa-symbol');
                const symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
                accumulator['symbol'] = symbol;
                return accumulator;
            }
        };
    }
};
var $2f7ebf3a194ce8e5$var$plugins = [
    $2f7ebf3a194ce8e5$var$InjectCSS,
    $2f7ebf3a194ce8e5$var$ReplaceElements,
    $2f7ebf3a194ce8e5$var$Layers,
    $2f7ebf3a194ce8e5$var$LayersCounter,
    $2f7ebf3a194ce8e5$var$LayersText,
    $2f7ebf3a194ce8e5$var$PseudoElements,
    $2f7ebf3a194ce8e5$var$MutationObserver$1,
    $2f7ebf3a194ce8e5$var$PowerTransforms,
    $2f7ebf3a194ce8e5$var$Masks,
    $2f7ebf3a194ce8e5$var$MissingIconIndicator,
    $2f7ebf3a194ce8e5$var$SvgSymbols
];
$2f7ebf3a194ce8e5$var$registerPlugins($2f7ebf3a194ce8e5$var$plugins, {
    mixoutsTo: $2f7ebf3a194ce8e5$export$644d8ea042df96a6
});
const $2f7ebf3a194ce8e5$export$4f8e844b2782642c = $2f7ebf3a194ce8e5$export$644d8ea042df96a6.noAuto;
const $2f7ebf3a194ce8e5$export$e506a1d27d1eaa20 = $2f7ebf3a194ce8e5$export$644d8ea042df96a6.config;
const $2f7ebf3a194ce8e5$export$b839f963c7dc0e34 = $2f7ebf3a194ce8e5$export$644d8ea042df96a6.library;
const $2f7ebf3a194ce8e5$export$df3a06d6289f983e = $2f7ebf3a194ce8e5$export$644d8ea042df96a6.dom;
const $2f7ebf3a194ce8e5$export$98e6a39c04603d36 = $2f7ebf3a194ce8e5$export$644d8ea042df96a6.parse;
const $2f7ebf3a194ce8e5$export$221fed4a47f597a5 = $2f7ebf3a194ce8e5$export$644d8ea042df96a6.findIconDefinition;
const $2f7ebf3a194ce8e5$export$a10125c086a4df16 = $2f7ebf3a194ce8e5$export$644d8ea042df96a6.toHtml;
const $2f7ebf3a194ce8e5$export$1ca1ec8b29a4ce27 = $2f7ebf3a194ce8e5$export$644d8ea042df96a6.icon;
const $2f7ebf3a194ce8e5$export$50a222d9023da98b = $2f7ebf3a194ce8e5$export$644d8ea042df96a6.layer;
const $2f7ebf3a194ce8e5$export$6f093cfa640b7166 = $2f7ebf3a194ce8e5$export$644d8ea042df96a6.text;
const $2f7ebf3a194ce8e5$export$e575061ef2a070eb = $2f7ebf3a194ce8e5$export$644d8ea042df96a6.counter;


var $3a2bc56e455da4fe$exports = {};
'use strict';
Object.defineProperty($3a2bc56e455da4fe$exports, '__esModule', {
    value: true
});
var $95af186336132ee7$exports = {};
'use strict';
Object.defineProperty($95af186336132ee7$exports, '__esModule', {
    value: true
});
var $95af186336132ee7$var$prefix = 'fas';
var $95af186336132ee7$var$iconName = 'triangle-exclamation';
var $95af186336132ee7$var$width = 512;
var $95af186336132ee7$var$height = 512;
var $95af186336132ee7$var$aliases = [
    9888,
    "exclamation-triangle",
    "warning"
];
var $95af186336132ee7$var$unicode = 'f071';
var $95af186336132ee7$var$svgPathData = 'M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480L40 480c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z';
$95af186336132ee7$exports.definition = {
    prefix: $95af186336132ee7$var$prefix,
    iconName: $95af186336132ee7$var$iconName,
    icon: [
        $95af186336132ee7$var$width,
        $95af186336132ee7$var$height,
        $95af186336132ee7$var$aliases,
        $95af186336132ee7$var$unicode,
        $95af186336132ee7$var$svgPathData
    ]
};
$95af186336132ee7$exports.faTriangleExclamation = $95af186336132ee7$exports.definition;
$95af186336132ee7$exports.prefix = $95af186336132ee7$var$prefix;
$95af186336132ee7$exports.iconName = $95af186336132ee7$var$iconName;
$95af186336132ee7$exports.width = $95af186336132ee7$var$width;
$95af186336132ee7$exports.height = $95af186336132ee7$var$height;
$95af186336132ee7$exports.ligatures = $95af186336132ee7$var$aliases;
$95af186336132ee7$exports.unicode = $95af186336132ee7$var$unicode;
$95af186336132ee7$exports.svgPathData = $95af186336132ee7$var$svgPathData;
$95af186336132ee7$exports.aliases = $95af186336132ee7$var$aliases;


$3a2bc56e455da4fe$exports.definition = {
    prefix: $95af186336132ee7$exports.prefix,
    iconName: $95af186336132ee7$exports.iconName,
    icon: [
        $95af186336132ee7$exports.width,
        $95af186336132ee7$exports.height,
        $95af186336132ee7$exports.aliases,
        $95af186336132ee7$exports.unicode,
        $95af186336132ee7$exports.svgPathData
    ]
};
$3a2bc56e455da4fe$exports.faExclamationTriangle = $3a2bc56e455da4fe$exports.definition;
$3a2bc56e455da4fe$exports.prefix = $95af186336132ee7$exports.prefix;
$3a2bc56e455da4fe$exports.iconName = $95af186336132ee7$exports.iconName;
$3a2bc56e455da4fe$exports.width = $95af186336132ee7$exports.width;
$3a2bc56e455da4fe$exports.height = $95af186336132ee7$exports.height;
$3a2bc56e455da4fe$exports.ligatures = $95af186336132ee7$exports.aliases;
$3a2bc56e455da4fe$exports.unicode = $95af186336132ee7$exports.unicode;
$3a2bc56e455da4fe$exports.svgPathData = $95af186336132ee7$exports.svgPathData;
$3a2bc56e455da4fe$exports.aliases = $95af186336132ee7$exports.aliases;


var $ee9a891ea173c571$exports = {};
'use strict';
Object.defineProperty($ee9a891ea173c571$exports, '__esModule', {
    value: true
});
var $ee9a891ea173c571$var$prefix = 'fas';
var $ee9a891ea173c571$var$iconName = 'chevron-right';
var $ee9a891ea173c571$var$width = 320;
var $ee9a891ea173c571$var$height = 512;
var $ee9a891ea173c571$var$aliases = [
    9002
];
var $ee9a891ea173c571$var$unicode = 'f054';
var $ee9a891ea173c571$var$svgPathData = 'M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z';
$ee9a891ea173c571$exports.definition = {
    prefix: $ee9a891ea173c571$var$prefix,
    iconName: $ee9a891ea173c571$var$iconName,
    icon: [
        $ee9a891ea173c571$var$width,
        $ee9a891ea173c571$var$height,
        $ee9a891ea173c571$var$aliases,
        $ee9a891ea173c571$var$unicode,
        $ee9a891ea173c571$var$svgPathData
    ]
};
$ee9a891ea173c571$exports.faChevronRight = $ee9a891ea173c571$exports.definition;
$ee9a891ea173c571$exports.prefix = $ee9a891ea173c571$var$prefix;
$ee9a891ea173c571$exports.iconName = $ee9a891ea173c571$var$iconName;
$ee9a891ea173c571$exports.width = $ee9a891ea173c571$var$width;
$ee9a891ea173c571$exports.height = $ee9a891ea173c571$var$height;
$ee9a891ea173c571$exports.ligatures = $ee9a891ea173c571$var$aliases;
$ee9a891ea173c571$exports.unicode = $ee9a891ea173c571$var$unicode;
$ee9a891ea173c571$exports.svgPathData = $ee9a891ea173c571$var$svgPathData;
$ee9a891ea173c571$exports.aliases = $ee9a891ea173c571$var$aliases;


var $7bb1e697a4926ee4$exports = {};
'use strict';
Object.defineProperty($7bb1e697a4926ee4$exports, '__esModule', {
    value: true
});
var $7bb1e697a4926ee4$var$prefix = 'fas';
var $7bb1e697a4926ee4$var$iconName = 'chevron-left';
var $7bb1e697a4926ee4$var$width = 320;
var $7bb1e697a4926ee4$var$height = 512;
var $7bb1e697a4926ee4$var$aliases = [
    9001
];
var $7bb1e697a4926ee4$var$unicode = 'f053';
var $7bb1e697a4926ee4$var$svgPathData = 'M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z';
$7bb1e697a4926ee4$exports.definition = {
    prefix: $7bb1e697a4926ee4$var$prefix,
    iconName: $7bb1e697a4926ee4$var$iconName,
    icon: [
        $7bb1e697a4926ee4$var$width,
        $7bb1e697a4926ee4$var$height,
        $7bb1e697a4926ee4$var$aliases,
        $7bb1e697a4926ee4$var$unicode,
        $7bb1e697a4926ee4$var$svgPathData
    ]
};
$7bb1e697a4926ee4$exports.faChevronLeft = $7bb1e697a4926ee4$exports.definition;
$7bb1e697a4926ee4$exports.prefix = $7bb1e697a4926ee4$var$prefix;
$7bb1e697a4926ee4$exports.iconName = $7bb1e697a4926ee4$var$iconName;
$7bb1e697a4926ee4$exports.width = $7bb1e697a4926ee4$var$width;
$7bb1e697a4926ee4$exports.height = $7bb1e697a4926ee4$var$height;
$7bb1e697a4926ee4$exports.ligatures = $7bb1e697a4926ee4$var$aliases;
$7bb1e697a4926ee4$exports.unicode = $7bb1e697a4926ee4$var$unicode;
$7bb1e697a4926ee4$exports.svgPathData = $7bb1e697a4926ee4$var$svgPathData;
$7bb1e697a4926ee4$exports.aliases = $7bb1e697a4926ee4$var$aliases;


var $b0aec77b2d8e52e2$exports = {};
'use strict';
Object.defineProperty($b0aec77b2d8e52e2$exports, '__esModule', {
    value: true
});
var $b0aec77b2d8e52e2$var$prefix = 'fas';
var $b0aec77b2d8e52e2$var$iconName = 'chevron-up';
var $b0aec77b2d8e52e2$var$width = 512;
var $b0aec77b2d8e52e2$var$height = 512;
var $b0aec77b2d8e52e2$var$aliases = [];
var $b0aec77b2d8e52e2$var$unicode = 'f077';
var $b0aec77b2d8e52e2$var$svgPathData = 'M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z';
$b0aec77b2d8e52e2$exports.definition = {
    prefix: $b0aec77b2d8e52e2$var$prefix,
    iconName: $b0aec77b2d8e52e2$var$iconName,
    icon: [
        $b0aec77b2d8e52e2$var$width,
        $b0aec77b2d8e52e2$var$height,
        $b0aec77b2d8e52e2$var$aliases,
        $b0aec77b2d8e52e2$var$unicode,
        $b0aec77b2d8e52e2$var$svgPathData
    ]
};
$b0aec77b2d8e52e2$exports.faChevronUp = $b0aec77b2d8e52e2$exports.definition;
$b0aec77b2d8e52e2$exports.prefix = $b0aec77b2d8e52e2$var$prefix;
$b0aec77b2d8e52e2$exports.iconName = $b0aec77b2d8e52e2$var$iconName;
$b0aec77b2d8e52e2$exports.width = $b0aec77b2d8e52e2$var$width;
$b0aec77b2d8e52e2$exports.height = $b0aec77b2d8e52e2$var$height;
$b0aec77b2d8e52e2$exports.ligatures = $b0aec77b2d8e52e2$var$aliases;
$b0aec77b2d8e52e2$exports.unicode = $b0aec77b2d8e52e2$var$unicode;
$b0aec77b2d8e52e2$exports.svgPathData = $b0aec77b2d8e52e2$var$svgPathData;
$b0aec77b2d8e52e2$exports.aliases = $b0aec77b2d8e52e2$var$aliases;


var $cebfe21aa7a84279$exports = {};
'use strict';
Object.defineProperty($cebfe21aa7a84279$exports, '__esModule', {
    value: true
});
var $cebfe21aa7a84279$var$prefix = 'fas';
var $cebfe21aa7a84279$var$iconName = 'chevron-down';
var $cebfe21aa7a84279$var$width = 512;
var $cebfe21aa7a84279$var$height = 512;
var $cebfe21aa7a84279$var$aliases = [];
var $cebfe21aa7a84279$var$unicode = 'f078';
var $cebfe21aa7a84279$var$svgPathData = 'M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z';
$cebfe21aa7a84279$exports.definition = {
    prefix: $cebfe21aa7a84279$var$prefix,
    iconName: $cebfe21aa7a84279$var$iconName,
    icon: [
        $cebfe21aa7a84279$var$width,
        $cebfe21aa7a84279$var$height,
        $cebfe21aa7a84279$var$aliases,
        $cebfe21aa7a84279$var$unicode,
        $cebfe21aa7a84279$var$svgPathData
    ]
};
$cebfe21aa7a84279$exports.faChevronDown = $cebfe21aa7a84279$exports.definition;
$cebfe21aa7a84279$exports.prefix = $cebfe21aa7a84279$var$prefix;
$cebfe21aa7a84279$exports.iconName = $cebfe21aa7a84279$var$iconName;
$cebfe21aa7a84279$exports.width = $cebfe21aa7a84279$var$width;
$cebfe21aa7a84279$exports.height = $cebfe21aa7a84279$var$height;
$cebfe21aa7a84279$exports.ligatures = $cebfe21aa7a84279$var$aliases;
$cebfe21aa7a84279$exports.unicode = $cebfe21aa7a84279$var$unicode;
$cebfe21aa7a84279$exports.svgPathData = $cebfe21aa7a84279$var$svgPathData;
$cebfe21aa7a84279$exports.aliases = $cebfe21aa7a84279$var$aliases;


var $4bf79fc3e0a2622b$exports = {};
'use strict';
Object.defineProperty($4bf79fc3e0a2622b$exports, '__esModule', {
    value: true
});
var $4bf79fc3e0a2622b$var$prefix = 'fas';
var $4bf79fc3e0a2622b$var$iconName = 'images';
var $4bf79fc3e0a2622b$var$width = 576;
var $4bf79fc3e0a2622b$var$height = 512;
var $4bf79fc3e0a2622b$var$aliases = [];
var $4bf79fc3e0a2622b$var$unicode = 'f302';
var $4bf79fc3e0a2622b$var$svgPathData = 'M160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32zM396 138.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S480.9 320 472 320l-144 0-48 0-80 0c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C360.5 132 368 128 376 128s15.5 4 20 10.7zM192 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224z';
$4bf79fc3e0a2622b$exports.definition = {
    prefix: $4bf79fc3e0a2622b$var$prefix,
    iconName: $4bf79fc3e0a2622b$var$iconName,
    icon: [
        $4bf79fc3e0a2622b$var$width,
        $4bf79fc3e0a2622b$var$height,
        $4bf79fc3e0a2622b$var$aliases,
        $4bf79fc3e0a2622b$var$unicode,
        $4bf79fc3e0a2622b$var$svgPathData
    ]
};
$4bf79fc3e0a2622b$exports.faImages = $4bf79fc3e0a2622b$exports.definition;
$4bf79fc3e0a2622b$exports.prefix = $4bf79fc3e0a2622b$var$prefix;
$4bf79fc3e0a2622b$exports.iconName = $4bf79fc3e0a2622b$var$iconName;
$4bf79fc3e0a2622b$exports.width = $4bf79fc3e0a2622b$var$width;
$4bf79fc3e0a2622b$exports.height = $4bf79fc3e0a2622b$var$height;
$4bf79fc3e0a2622b$exports.ligatures = $4bf79fc3e0a2622b$var$aliases;
$4bf79fc3e0a2622b$exports.unicode = $4bf79fc3e0a2622b$var$unicode;
$4bf79fc3e0a2622b$exports.svgPathData = $4bf79fc3e0a2622b$var$svgPathData;
$4bf79fc3e0a2622b$exports.aliases = $4bf79fc3e0a2622b$var$aliases;


var $782edb54b9a12500$exports = {};
'use strict';
Object.defineProperty($782edb54b9a12500$exports, '__esModule', {
    value: true
});
var $782edb54b9a12500$var$prefix = 'fas';
var $782edb54b9a12500$var$iconName = 'info';
var $782edb54b9a12500$var$width = 192;
var $782edb54b9a12500$var$height = 512;
var $782edb54b9a12500$var$aliases = [];
var $782edb54b9a12500$var$unicode = 'f129';
var $782edb54b9a12500$var$svgPathData = 'M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192-32 0c-17.7 0-32-14.3-32-32z';
$782edb54b9a12500$exports.definition = {
    prefix: $782edb54b9a12500$var$prefix,
    iconName: $782edb54b9a12500$var$iconName,
    icon: [
        $782edb54b9a12500$var$width,
        $782edb54b9a12500$var$height,
        $782edb54b9a12500$var$aliases,
        $782edb54b9a12500$var$unicode,
        $782edb54b9a12500$var$svgPathData
    ]
};
$782edb54b9a12500$exports.faInfo = $782edb54b9a12500$exports.definition;
$782edb54b9a12500$exports.prefix = $782edb54b9a12500$var$prefix;
$782edb54b9a12500$exports.iconName = $782edb54b9a12500$var$iconName;
$782edb54b9a12500$exports.width = $782edb54b9a12500$var$width;
$782edb54b9a12500$exports.height = $782edb54b9a12500$var$height;
$782edb54b9a12500$exports.ligatures = $782edb54b9a12500$var$aliases;
$782edb54b9a12500$exports.unicode = $782edb54b9a12500$var$unicode;
$782edb54b9a12500$exports.svgPathData = $782edb54b9a12500$var$svgPathData;
$782edb54b9a12500$exports.aliases = $782edb54b9a12500$var$aliases;


var $69448632564d9fae$exports = {};
'use strict';
Object.defineProperty($69448632564d9fae$exports, '__esModule', {
    value: true
});
var $69448632564d9fae$var$prefix = 'fas';
var $69448632564d9fae$var$iconName = 'phone';
var $69448632564d9fae$var$width = 512;
var $69448632564d9fae$var$height = 512;
var $69448632564d9fae$var$aliases = [
    128222,
    128379
];
var $69448632564d9fae$var$unicode = 'f095';
var $69448632564d9fae$var$svgPathData = 'M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z';
$69448632564d9fae$exports.definition = {
    prefix: $69448632564d9fae$var$prefix,
    iconName: $69448632564d9fae$var$iconName,
    icon: [
        $69448632564d9fae$var$width,
        $69448632564d9fae$var$height,
        $69448632564d9fae$var$aliases,
        $69448632564d9fae$var$unicode,
        $69448632564d9fae$var$svgPathData
    ]
};
$69448632564d9fae$exports.faPhone = $69448632564d9fae$exports.definition;
$69448632564d9fae$exports.prefix = $69448632564d9fae$var$prefix;
$69448632564d9fae$exports.iconName = $69448632564d9fae$var$iconName;
$69448632564d9fae$exports.width = $69448632564d9fae$var$width;
$69448632564d9fae$exports.height = $69448632564d9fae$var$height;
$69448632564d9fae$exports.ligatures = $69448632564d9fae$var$aliases;
$69448632564d9fae$exports.unicode = $69448632564d9fae$var$unicode;
$69448632564d9fae$exports.svgPathData = $69448632564d9fae$var$svgPathData;
$69448632564d9fae$exports.aliases = $69448632564d9fae$var$aliases;


var $c8f315ddd9db297b$exports = {};
'use strict';
Object.defineProperty($c8f315ddd9db297b$exports, '__esModule', {
    value: true
});
var $c8f315ddd9db297b$var$prefix = 'fas';
var $c8f315ddd9db297b$var$iconName = 'envelope';
var $c8f315ddd9db297b$var$width = 512;
var $c8f315ddd9db297b$var$height = 512;
var $c8f315ddd9db297b$var$aliases = [
    128386,
    9993,
    61443
];
var $c8f315ddd9db297b$var$unicode = 'f0e0';
var $c8f315ddd9db297b$var$svgPathData = 'M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48L48 64zM0 176L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-208L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z';
$c8f315ddd9db297b$exports.definition = {
    prefix: $c8f315ddd9db297b$var$prefix,
    iconName: $c8f315ddd9db297b$var$iconName,
    icon: [
        $c8f315ddd9db297b$var$width,
        $c8f315ddd9db297b$var$height,
        $c8f315ddd9db297b$var$aliases,
        $c8f315ddd9db297b$var$unicode,
        $c8f315ddd9db297b$var$svgPathData
    ]
};
$c8f315ddd9db297b$exports.faEnvelope = $c8f315ddd9db297b$exports.definition;
$c8f315ddd9db297b$exports.prefix = $c8f315ddd9db297b$var$prefix;
$c8f315ddd9db297b$exports.iconName = $c8f315ddd9db297b$var$iconName;
$c8f315ddd9db297b$exports.width = $c8f315ddd9db297b$var$width;
$c8f315ddd9db297b$exports.height = $c8f315ddd9db297b$var$height;
$c8f315ddd9db297b$exports.ligatures = $c8f315ddd9db297b$var$aliases;
$c8f315ddd9db297b$exports.unicode = $c8f315ddd9db297b$var$unicode;
$c8f315ddd9db297b$exports.svgPathData = $c8f315ddd9db297b$var$svgPathData;
$c8f315ddd9db297b$exports.aliases = $c8f315ddd9db297b$var$aliases;


var $60e51ca178edefdc$exports = {};
'use strict';
Object.defineProperty($60e51ca178edefdc$exports, '__esModule', {
    value: true
});
var $60e51ca178edefdc$var$prefix = 'fas';
var $60e51ca178edefdc$var$iconName = 'check';
var $60e51ca178edefdc$var$width = 448;
var $60e51ca178edefdc$var$height = 512;
var $60e51ca178edefdc$var$aliases = [
    10003,
    10004
];
var $60e51ca178edefdc$var$unicode = 'f00c';
var $60e51ca178edefdc$var$svgPathData = 'M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z';
$60e51ca178edefdc$exports.definition = {
    prefix: $60e51ca178edefdc$var$prefix,
    iconName: $60e51ca178edefdc$var$iconName,
    icon: [
        $60e51ca178edefdc$var$width,
        $60e51ca178edefdc$var$height,
        $60e51ca178edefdc$var$aliases,
        $60e51ca178edefdc$var$unicode,
        $60e51ca178edefdc$var$svgPathData
    ]
};
$60e51ca178edefdc$exports.faCheck = $60e51ca178edefdc$exports.definition;
$60e51ca178edefdc$exports.prefix = $60e51ca178edefdc$var$prefix;
$60e51ca178edefdc$exports.iconName = $60e51ca178edefdc$var$iconName;
$60e51ca178edefdc$exports.width = $60e51ca178edefdc$var$width;
$60e51ca178edefdc$exports.height = $60e51ca178edefdc$var$height;
$60e51ca178edefdc$exports.ligatures = $60e51ca178edefdc$var$aliases;
$60e51ca178edefdc$exports.unicode = $60e51ca178edefdc$var$unicode;
$60e51ca178edefdc$exports.svgPathData = $60e51ca178edefdc$var$svgPathData;
$60e51ca178edefdc$exports.aliases = $60e51ca178edefdc$var$aliases;


var $a7574a69e3799d7d$exports = {};
'use strict';
Object.defineProperty($a7574a69e3799d7d$exports, '__esModule', {
    value: true
});
var $9d03173d93d2d06f$exports = {};
'use strict';
Object.defineProperty($9d03173d93d2d06f$exports, '__esModule', {
    value: true
});
var $9d03173d93d2d06f$var$prefix = 'fas';
var $9d03173d93d2d06f$var$iconName = 'circle-info';
var $9d03173d93d2d06f$var$width = 512;
var $9d03173d93d2d06f$var$height = 512;
var $9d03173d93d2d06f$var$aliases = [
    "info-circle"
];
var $9d03173d93d2d06f$var$unicode = 'f05a';
var $9d03173d93d2d06f$var$svgPathData = 'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z';
$9d03173d93d2d06f$exports.definition = {
    prefix: $9d03173d93d2d06f$var$prefix,
    iconName: $9d03173d93d2d06f$var$iconName,
    icon: [
        $9d03173d93d2d06f$var$width,
        $9d03173d93d2d06f$var$height,
        $9d03173d93d2d06f$var$aliases,
        $9d03173d93d2d06f$var$unicode,
        $9d03173d93d2d06f$var$svgPathData
    ]
};
$9d03173d93d2d06f$exports.faCircleInfo = $9d03173d93d2d06f$exports.definition;
$9d03173d93d2d06f$exports.prefix = $9d03173d93d2d06f$var$prefix;
$9d03173d93d2d06f$exports.iconName = $9d03173d93d2d06f$var$iconName;
$9d03173d93d2d06f$exports.width = $9d03173d93d2d06f$var$width;
$9d03173d93d2d06f$exports.height = $9d03173d93d2d06f$var$height;
$9d03173d93d2d06f$exports.ligatures = $9d03173d93d2d06f$var$aliases;
$9d03173d93d2d06f$exports.unicode = $9d03173d93d2d06f$var$unicode;
$9d03173d93d2d06f$exports.svgPathData = $9d03173d93d2d06f$var$svgPathData;
$9d03173d93d2d06f$exports.aliases = $9d03173d93d2d06f$var$aliases;


$a7574a69e3799d7d$exports.definition = {
    prefix: $9d03173d93d2d06f$exports.prefix,
    iconName: $9d03173d93d2d06f$exports.iconName,
    icon: [
        $9d03173d93d2d06f$exports.width,
        $9d03173d93d2d06f$exports.height,
        $9d03173d93d2d06f$exports.aliases,
        $9d03173d93d2d06f$exports.unicode,
        $9d03173d93d2d06f$exports.svgPathData
    ]
};
$a7574a69e3799d7d$exports.faInfoCircle = $a7574a69e3799d7d$exports.definition;
$a7574a69e3799d7d$exports.prefix = $9d03173d93d2d06f$exports.prefix;
$a7574a69e3799d7d$exports.iconName = $9d03173d93d2d06f$exports.iconName;
$a7574a69e3799d7d$exports.width = $9d03173d93d2d06f$exports.width;
$a7574a69e3799d7d$exports.height = $9d03173d93d2d06f$exports.height;
$a7574a69e3799d7d$exports.ligatures = $9d03173d93d2d06f$exports.aliases;
$a7574a69e3799d7d$exports.unicode = $9d03173d93d2d06f$exports.unicode;
$a7574a69e3799d7d$exports.svgPathData = $9d03173d93d2d06f$exports.svgPathData;
$a7574a69e3799d7d$exports.aliases = $9d03173d93d2d06f$exports.aliases;


var $405f53e0f028c073$exports = {};
'use strict';
Object.defineProperty($405f53e0f028c073$exports, '__esModule', {
    value: true
});
var $405f53e0f028c073$var$prefix = 'fas';
var $405f53e0f028c073$var$iconName = 'quote-left';
var $405f53e0f028c073$var$width = 448;
var $405f53e0f028c073$var$height = 512;
var $405f53e0f028c073$var$aliases = [
    8220,
    "quote-left-alt"
];
var $405f53e0f028c073$var$unicode = 'f10d';
var $405f53e0f028c073$var$svgPathData = 'M0 216C0 149.7 53.7 96 120 96l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72zm256 0c0-66.3 53.7-120 120-120l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72z';
$405f53e0f028c073$exports.definition = {
    prefix: $405f53e0f028c073$var$prefix,
    iconName: $405f53e0f028c073$var$iconName,
    icon: [
        $405f53e0f028c073$var$width,
        $405f53e0f028c073$var$height,
        $405f53e0f028c073$var$aliases,
        $405f53e0f028c073$var$unicode,
        $405f53e0f028c073$var$svgPathData
    ]
};
$405f53e0f028c073$exports.faQuoteLeft = $405f53e0f028c073$exports.definition;
$405f53e0f028c073$exports.prefix = $405f53e0f028c073$var$prefix;
$405f53e0f028c073$exports.iconName = $405f53e0f028c073$var$iconName;
$405f53e0f028c073$exports.width = $405f53e0f028c073$var$width;
$405f53e0f028c073$exports.height = $405f53e0f028c073$var$height;
$405f53e0f028c073$exports.ligatures = $405f53e0f028c073$var$aliases;
$405f53e0f028c073$exports.unicode = $405f53e0f028c073$var$unicode;
$405f53e0f028c073$exports.svgPathData = $405f53e0f028c073$var$svgPathData;
$405f53e0f028c073$exports.aliases = $405f53e0f028c073$var$aliases;


var $1d12c6e8ecc18a6f$exports = {};
'use strict';
Object.defineProperty($1d12c6e8ecc18a6f$exports, '__esModule', {
    value: true
});
var $c378a83d44ecccfc$exports = {};
'use strict';
Object.defineProperty($c378a83d44ecccfc$exports, '__esModule', {
    value: true
});
var $c378a83d44ecccfc$var$prefix = 'fas';
var $c378a83d44ecccfc$var$iconName = 'location-dot';
var $c378a83d44ecccfc$var$width = 384;
var $c378a83d44ecccfc$var$height = 512;
var $c378a83d44ecccfc$var$aliases = [
    "map-marker-alt"
];
var $c378a83d44ecccfc$var$unicode = 'f3c5';
var $c378a83d44ecccfc$var$svgPathData = 'M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z';
$c378a83d44ecccfc$exports.definition = {
    prefix: $c378a83d44ecccfc$var$prefix,
    iconName: $c378a83d44ecccfc$var$iconName,
    icon: [
        $c378a83d44ecccfc$var$width,
        $c378a83d44ecccfc$var$height,
        $c378a83d44ecccfc$var$aliases,
        $c378a83d44ecccfc$var$unicode,
        $c378a83d44ecccfc$var$svgPathData
    ]
};
$c378a83d44ecccfc$exports.faLocationDot = $c378a83d44ecccfc$exports.definition;
$c378a83d44ecccfc$exports.prefix = $c378a83d44ecccfc$var$prefix;
$c378a83d44ecccfc$exports.iconName = $c378a83d44ecccfc$var$iconName;
$c378a83d44ecccfc$exports.width = $c378a83d44ecccfc$var$width;
$c378a83d44ecccfc$exports.height = $c378a83d44ecccfc$var$height;
$c378a83d44ecccfc$exports.ligatures = $c378a83d44ecccfc$var$aliases;
$c378a83d44ecccfc$exports.unicode = $c378a83d44ecccfc$var$unicode;
$c378a83d44ecccfc$exports.svgPathData = $c378a83d44ecccfc$var$svgPathData;
$c378a83d44ecccfc$exports.aliases = $c378a83d44ecccfc$var$aliases;


$1d12c6e8ecc18a6f$exports.definition = {
    prefix: $c378a83d44ecccfc$exports.prefix,
    iconName: $c378a83d44ecccfc$exports.iconName,
    icon: [
        $c378a83d44ecccfc$exports.width,
        $c378a83d44ecccfc$exports.height,
        $c378a83d44ecccfc$exports.aliases,
        $c378a83d44ecccfc$exports.unicode,
        $c378a83d44ecccfc$exports.svgPathData
    ]
};
$1d12c6e8ecc18a6f$exports.faMapMarkerAlt = $1d12c6e8ecc18a6f$exports.definition;
$1d12c6e8ecc18a6f$exports.prefix = $c378a83d44ecccfc$exports.prefix;
$1d12c6e8ecc18a6f$exports.iconName = $c378a83d44ecccfc$exports.iconName;
$1d12c6e8ecc18a6f$exports.width = $c378a83d44ecccfc$exports.width;
$1d12c6e8ecc18a6f$exports.height = $c378a83d44ecccfc$exports.height;
$1d12c6e8ecc18a6f$exports.ligatures = $c378a83d44ecccfc$exports.aliases;
$1d12c6e8ecc18a6f$exports.unicode = $c378a83d44ecccfc$exports.unicode;
$1d12c6e8ecc18a6f$exports.svgPathData = $c378a83d44ecccfc$exports.svgPathData;
$1d12c6e8ecc18a6f$exports.aliases = $c378a83d44ecccfc$exports.aliases;


var $a46035823bb47651$exports = {};
'use strict';
Object.defineProperty($a46035823bb47651$exports, '__esModule', {
    value: true
});
var $dc545a67001055c2$exports = {};
'use strict';
Object.defineProperty($dc545a67001055c2$exports, '__esModule', {
    value: true
});
var $dc545a67001055c2$var$prefix = 'fas';
var $dc545a67001055c2$var$iconName = 'xmark';
var $dc545a67001055c2$var$width = 384;
var $dc545a67001055c2$var$height = 512;
var $dc545a67001055c2$var$aliases = [
    128473,
    10005,
    10006,
    10060,
    215,
    "close",
    "multiply",
    "remove",
    "times"
];
var $dc545a67001055c2$var$unicode = 'f00d';
var $dc545a67001055c2$var$svgPathData = 'M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z';
$dc545a67001055c2$exports.definition = {
    prefix: $dc545a67001055c2$var$prefix,
    iconName: $dc545a67001055c2$var$iconName,
    icon: [
        $dc545a67001055c2$var$width,
        $dc545a67001055c2$var$height,
        $dc545a67001055c2$var$aliases,
        $dc545a67001055c2$var$unicode,
        $dc545a67001055c2$var$svgPathData
    ]
};
$dc545a67001055c2$exports.faXmark = $dc545a67001055c2$exports.definition;
$dc545a67001055c2$exports.prefix = $dc545a67001055c2$var$prefix;
$dc545a67001055c2$exports.iconName = $dc545a67001055c2$var$iconName;
$dc545a67001055c2$exports.width = $dc545a67001055c2$var$width;
$dc545a67001055c2$exports.height = $dc545a67001055c2$var$height;
$dc545a67001055c2$exports.ligatures = $dc545a67001055c2$var$aliases;
$dc545a67001055c2$exports.unicode = $dc545a67001055c2$var$unicode;
$dc545a67001055c2$exports.svgPathData = $dc545a67001055c2$var$svgPathData;
$dc545a67001055c2$exports.aliases = $dc545a67001055c2$var$aliases;


$a46035823bb47651$exports.definition = {
    prefix: $dc545a67001055c2$exports.prefix,
    iconName: $dc545a67001055c2$exports.iconName,
    icon: [
        $dc545a67001055c2$exports.width,
        $dc545a67001055c2$exports.height,
        $dc545a67001055c2$exports.aliases,
        $dc545a67001055c2$exports.unicode,
        $dc545a67001055c2$exports.svgPathData
    ]
};
$a46035823bb47651$exports.faTimes = $a46035823bb47651$exports.definition;
$a46035823bb47651$exports.prefix = $dc545a67001055c2$exports.prefix;
$a46035823bb47651$exports.iconName = $dc545a67001055c2$exports.iconName;
$a46035823bb47651$exports.width = $dc545a67001055c2$exports.width;
$a46035823bb47651$exports.height = $dc545a67001055c2$exports.height;
$a46035823bb47651$exports.ligatures = $dc545a67001055c2$exports.aliases;
$a46035823bb47651$exports.unicode = $dc545a67001055c2$exports.unicode;
$a46035823bb47651$exports.svgPathData = $dc545a67001055c2$exports.svgPathData;
$a46035823bb47651$exports.aliases = $dc545a67001055c2$exports.aliases;


var $9e51484bffff5392$exports = {};
'use strict';
Object.defineProperty($9e51484bffff5392$exports, '__esModule', {
    value: true
});
var $9e51484bffff5392$var$prefix = 'fab';
var $9e51484bffff5392$var$iconName = 'facebook-f';
var $9e51484bffff5392$var$width = 320;
var $9e51484bffff5392$var$height = 512;
var $9e51484bffff5392$var$aliases = [];
var $9e51484bffff5392$var$unicode = 'f39e';
var $9e51484bffff5392$var$svgPathData = 'M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z';
$9e51484bffff5392$exports.definition = {
    prefix: $9e51484bffff5392$var$prefix,
    iconName: $9e51484bffff5392$var$iconName,
    icon: [
        $9e51484bffff5392$var$width,
        $9e51484bffff5392$var$height,
        $9e51484bffff5392$var$aliases,
        $9e51484bffff5392$var$unicode,
        $9e51484bffff5392$var$svgPathData
    ]
};
$9e51484bffff5392$exports.faFacebookF = $9e51484bffff5392$exports.definition;
$9e51484bffff5392$exports.prefix = $9e51484bffff5392$var$prefix;
$9e51484bffff5392$exports.iconName = $9e51484bffff5392$var$iconName;
$9e51484bffff5392$exports.width = $9e51484bffff5392$var$width;
$9e51484bffff5392$exports.height = $9e51484bffff5392$var$height;
$9e51484bffff5392$exports.ligatures = $9e51484bffff5392$var$aliases;
$9e51484bffff5392$exports.unicode = $9e51484bffff5392$var$unicode;
$9e51484bffff5392$exports.svgPathData = $9e51484bffff5392$var$svgPathData;
$9e51484bffff5392$exports.aliases = $9e51484bffff5392$var$aliases;


var $4249215276a820c2$exports = {};
'use strict';
Object.defineProperty($4249215276a820c2$exports, '__esModule', {
    value: true
});
var $4249215276a820c2$var$prefix = 'fab';
var $4249215276a820c2$var$iconName = 'twitter';
var $4249215276a820c2$var$width = 512;
var $4249215276a820c2$var$height = 512;
var $4249215276a820c2$var$aliases = [];
var $4249215276a820c2$var$unicode = 'f099';
var $4249215276a820c2$var$svgPathData = 'M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z';
$4249215276a820c2$exports.definition = {
    prefix: $4249215276a820c2$var$prefix,
    iconName: $4249215276a820c2$var$iconName,
    icon: [
        $4249215276a820c2$var$width,
        $4249215276a820c2$var$height,
        $4249215276a820c2$var$aliases,
        $4249215276a820c2$var$unicode,
        $4249215276a820c2$var$svgPathData
    ]
};
$4249215276a820c2$exports.faTwitter = $4249215276a820c2$exports.definition;
$4249215276a820c2$exports.prefix = $4249215276a820c2$var$prefix;
$4249215276a820c2$exports.iconName = $4249215276a820c2$var$iconName;
$4249215276a820c2$exports.width = $4249215276a820c2$var$width;
$4249215276a820c2$exports.height = $4249215276a820c2$var$height;
$4249215276a820c2$exports.ligatures = $4249215276a820c2$var$aliases;
$4249215276a820c2$exports.unicode = $4249215276a820c2$var$unicode;
$4249215276a820c2$exports.svgPathData = $4249215276a820c2$var$svgPathData;
$4249215276a820c2$exports.aliases = $4249215276a820c2$var$aliases;


var $0c29c32ac8432756$exports = {};
'use strict';
Object.defineProperty($0c29c32ac8432756$exports, '__esModule', {
    value: true
});
var $0c29c32ac8432756$var$prefix = 'fab';
var $0c29c32ac8432756$var$iconName = 'instagram';
var $0c29c32ac8432756$var$width = 448;
var $0c29c32ac8432756$var$height = 512;
var $0c29c32ac8432756$var$aliases = [];
var $0c29c32ac8432756$var$unicode = 'f16d';
var $0c29c32ac8432756$var$svgPathData = 'M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z';
$0c29c32ac8432756$exports.definition = {
    prefix: $0c29c32ac8432756$var$prefix,
    iconName: $0c29c32ac8432756$var$iconName,
    icon: [
        $0c29c32ac8432756$var$width,
        $0c29c32ac8432756$var$height,
        $0c29c32ac8432756$var$aliases,
        $0c29c32ac8432756$var$unicode,
        $0c29c32ac8432756$var$svgPathData
    ]
};
$0c29c32ac8432756$exports.faInstagram = $0c29c32ac8432756$exports.definition;
$0c29c32ac8432756$exports.prefix = $0c29c32ac8432756$var$prefix;
$0c29c32ac8432756$exports.iconName = $0c29c32ac8432756$var$iconName;
$0c29c32ac8432756$exports.width = $0c29c32ac8432756$var$width;
$0c29c32ac8432756$exports.height = $0c29c32ac8432756$var$height;
$0c29c32ac8432756$exports.ligatures = $0c29c32ac8432756$var$aliases;
$0c29c32ac8432756$exports.unicode = $0c29c32ac8432756$var$unicode;
$0c29c32ac8432756$exports.svgPathData = $0c29c32ac8432756$var$svgPathData;
$0c29c32ac8432756$exports.aliases = $0c29c32ac8432756$var$aliases;


var $b79bf6e309d792ff$exports = {};
'use strict';
Object.defineProperty($b79bf6e309d792ff$exports, '__esModule', {
    value: true
});
var $b79bf6e309d792ff$var$prefix = 'fab';
var $b79bf6e309d792ff$var$iconName = 'youtube';
var $b79bf6e309d792ff$var$width = 576;
var $b79bf6e309d792ff$var$height = 512;
var $b79bf6e309d792ff$var$aliases = [
    61802
];
var $b79bf6e309d792ff$var$unicode = 'f167';
var $b79bf6e309d792ff$var$svgPathData = 'M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z';
$b79bf6e309d792ff$exports.definition = {
    prefix: $b79bf6e309d792ff$var$prefix,
    iconName: $b79bf6e309d792ff$var$iconName,
    icon: [
        $b79bf6e309d792ff$var$width,
        $b79bf6e309d792ff$var$height,
        $b79bf6e309d792ff$var$aliases,
        $b79bf6e309d792ff$var$unicode,
        $b79bf6e309d792ff$var$svgPathData
    ]
};
$b79bf6e309d792ff$exports.faYoutube = $b79bf6e309d792ff$exports.definition;
$b79bf6e309d792ff$exports.prefix = $b79bf6e309d792ff$var$prefix;
$b79bf6e309d792ff$exports.iconName = $b79bf6e309d792ff$var$iconName;
$b79bf6e309d792ff$exports.width = $b79bf6e309d792ff$var$width;
$b79bf6e309d792ff$exports.height = $b79bf6e309d792ff$var$height;
$b79bf6e309d792ff$exports.ligatures = $b79bf6e309d792ff$var$aliases;
$b79bf6e309d792ff$exports.unicode = $b79bf6e309d792ff$var$unicode;
$b79bf6e309d792ff$exports.svgPathData = $b79bf6e309d792ff$var$svgPathData;
$b79bf6e309d792ff$exports.aliases = $b79bf6e309d792ff$var$aliases;


var $2f2aa46c8a16c007$exports = {};
'use strict';
Object.defineProperty($2f2aa46c8a16c007$exports, '__esModule', {
    value: true
});
var $2f2aa46c8a16c007$var$prefix = 'fab';
var $2f2aa46c8a16c007$var$iconName = 'pinterest';
var $2f2aa46c8a16c007$var$width = 496;
var $2f2aa46c8a16c007$var$height = 512;
var $2f2aa46c8a16c007$var$aliases = [];
var $2f2aa46c8a16c007$var$unicode = 'f0d2';
var $2f2aa46c8a16c007$var$svgPathData = 'M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z';
$2f2aa46c8a16c007$exports.definition = {
    prefix: $2f2aa46c8a16c007$var$prefix,
    iconName: $2f2aa46c8a16c007$var$iconName,
    icon: [
        $2f2aa46c8a16c007$var$width,
        $2f2aa46c8a16c007$var$height,
        $2f2aa46c8a16c007$var$aliases,
        $2f2aa46c8a16c007$var$unicode,
        $2f2aa46c8a16c007$var$svgPathData
    ]
};
$2f2aa46c8a16c007$exports.faPinterest = $2f2aa46c8a16c007$exports.definition;
$2f2aa46c8a16c007$exports.prefix = $2f2aa46c8a16c007$var$prefix;
$2f2aa46c8a16c007$exports.iconName = $2f2aa46c8a16c007$var$iconName;
$2f2aa46c8a16c007$exports.width = $2f2aa46c8a16c007$var$width;
$2f2aa46c8a16c007$exports.height = $2f2aa46c8a16c007$var$height;
$2f2aa46c8a16c007$exports.ligatures = $2f2aa46c8a16c007$var$aliases;
$2f2aa46c8a16c007$exports.unicode = $2f2aa46c8a16c007$var$unicode;
$2f2aa46c8a16c007$exports.svgPathData = $2f2aa46c8a16c007$var$svgPathData;
$2f2aa46c8a16c007$exports.aliases = $2f2aa46c8a16c007$var$aliases;


var $465446d30938e8c3$exports = {};
'use strict';
Object.defineProperty($465446d30938e8c3$exports, '__esModule', {
    value: true
});
var $465446d30938e8c3$var$prefix = 'fab';
var $465446d30938e8c3$var$iconName = 'houzz';
var $465446d30938e8c3$var$width = 448;
var $465446d30938e8c3$var$height = 512;
var $465446d30938e8c3$var$aliases = [];
var $465446d30938e8c3$var$unicode = 'f27c';
var $465446d30938e8c3$var$svgPathData = 'M275.9 330.7H171.3V480H17V32h109.5v104.5l305.1 85.6V480H275.9z';
$465446d30938e8c3$exports.definition = {
    prefix: $465446d30938e8c3$var$prefix,
    iconName: $465446d30938e8c3$var$iconName,
    icon: [
        $465446d30938e8c3$var$width,
        $465446d30938e8c3$var$height,
        $465446d30938e8c3$var$aliases,
        $465446d30938e8c3$var$unicode,
        $465446d30938e8c3$var$svgPathData
    ]
};
$465446d30938e8c3$exports.faHouzz = $465446d30938e8c3$exports.definition;
$465446d30938e8c3$exports.prefix = $465446d30938e8c3$var$prefix;
$465446d30938e8c3$exports.iconName = $465446d30938e8c3$var$iconName;
$465446d30938e8c3$exports.width = $465446d30938e8c3$var$width;
$465446d30938e8c3$exports.height = $465446d30938e8c3$var$height;
$465446d30938e8c3$exports.ligatures = $465446d30938e8c3$var$aliases;
$465446d30938e8c3$exports.unicode = $465446d30938e8c3$var$unicode;
$465446d30938e8c3$exports.svgPathData = $465446d30938e8c3$var$svgPathData;
$465446d30938e8c3$exports.aliases = $465446d30938e8c3$var$aliases;


var $8e1fd11806c205a6$exports = {};
'use strict';
Object.defineProperty($8e1fd11806c205a6$exports, '__esModule', {
    value: true
});
var $8e1fd11806c205a6$var$prefix = 'fab';
var $8e1fd11806c205a6$var$iconName = 'linkedin-in';
var $8e1fd11806c205a6$var$width = 448;
var $8e1fd11806c205a6$var$height = 512;
var $8e1fd11806c205a6$var$aliases = [];
var $8e1fd11806c205a6$var$unicode = 'f0e1';
var $8e1fd11806c205a6$var$svgPathData = 'M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z';
$8e1fd11806c205a6$exports.definition = {
    prefix: $8e1fd11806c205a6$var$prefix,
    iconName: $8e1fd11806c205a6$var$iconName,
    icon: [
        $8e1fd11806c205a6$var$width,
        $8e1fd11806c205a6$var$height,
        $8e1fd11806c205a6$var$aliases,
        $8e1fd11806c205a6$var$unicode,
        $8e1fd11806c205a6$var$svgPathData
    ]
};
$8e1fd11806c205a6$exports.faLinkedinIn = $8e1fd11806c205a6$exports.definition;
$8e1fd11806c205a6$exports.prefix = $8e1fd11806c205a6$var$prefix;
$8e1fd11806c205a6$exports.iconName = $8e1fd11806c205a6$var$iconName;
$8e1fd11806c205a6$exports.width = $8e1fd11806c205a6$var$width;
$8e1fd11806c205a6$exports.height = $8e1fd11806c205a6$var$height;
$8e1fd11806c205a6$exports.ligatures = $8e1fd11806c205a6$var$aliases;
$8e1fd11806c205a6$exports.unicode = $8e1fd11806c205a6$var$unicode;
$8e1fd11806c205a6$exports.svgPathData = $8e1fd11806c205a6$var$svgPathData;
$8e1fd11806c205a6$exports.aliases = $8e1fd11806c205a6$var$aliases;


var $d366bfbd4d81c0c0$exports = {};
'use strict';
Object.defineProperty($d366bfbd4d81c0c0$exports, '__esModule', {
    value: true
});
var $d366bfbd4d81c0c0$var$prefix = 'fab';
var $d366bfbd4d81c0c0$var$iconName = 'xing';
var $d366bfbd4d81c0c0$var$width = 384;
var $d366bfbd4d81c0c0$var$height = 512;
var $d366bfbd4d81c0c0$var$aliases = [];
var $d366bfbd4d81c0c0$var$unicode = 'f168';
var $d366bfbd4d81c0c0$var$svgPathData = 'M162.7 210c-1.8 3.3-25.2 44.4-70.1 123.5-4.9 8.3-10.8 12.5-17.7 12.5H9.8c-7.7 0-12.1-7.5-8.5-14.4l69-121.3c.2 0 .2-.1 0-.3l-43.9-75.6c-4.3-7.8.3-14.1 8.5-14.1H100c7.3 0 13.3 4.1 18 12.2l44.7 77.5zM382.6 46.1l-144 253v.3L330.2 466c3.9 7.1.2 14.1-8.5 14.1h-65.2c-7.6 0-13.6-4-18-12.2l-92.4-168.5c3.3-5.8 51.5-90.8 144.8-255.2 4.6-8.1 10.4-12.2 17.5-12.2h65.7c8 0 12.3 6.7 8.5 14.1z';
$d366bfbd4d81c0c0$exports.definition = {
    prefix: $d366bfbd4d81c0c0$var$prefix,
    iconName: $d366bfbd4d81c0c0$var$iconName,
    icon: [
        $d366bfbd4d81c0c0$var$width,
        $d366bfbd4d81c0c0$var$height,
        $d366bfbd4d81c0c0$var$aliases,
        $d366bfbd4d81c0c0$var$unicode,
        $d366bfbd4d81c0c0$var$svgPathData
    ]
};
$d366bfbd4d81c0c0$exports.faXing = $d366bfbd4d81c0c0$exports.definition;
$d366bfbd4d81c0c0$exports.prefix = $d366bfbd4d81c0c0$var$prefix;
$d366bfbd4d81c0c0$exports.iconName = $d366bfbd4d81c0c0$var$iconName;
$d366bfbd4d81c0c0$exports.width = $d366bfbd4d81c0c0$var$width;
$d366bfbd4d81c0c0$exports.height = $d366bfbd4d81c0c0$var$height;
$d366bfbd4d81c0c0$exports.ligatures = $d366bfbd4d81c0c0$var$aliases;
$d366bfbd4d81c0c0$exports.unicode = $d366bfbd4d81c0c0$var$unicode;
$d366bfbd4d81c0c0$exports.svgPathData = $d366bfbd4d81c0c0$var$svgPathData;
$d366bfbd4d81c0c0$exports.aliases = $d366bfbd4d81c0c0$var$aliases;


var $0b637f68d7139cf0$exports = {};
'use strict';
Object.defineProperty($0b637f68d7139cf0$exports, '__esModule', {
    value: true
});
var $fa8c16e591014208$exports = {};
'use strict';
Object.defineProperty($fa8c16e591014208$exports, '__esModule', {
    value: true
});
var $fa8c16e591014208$var$prefix = 'fal';
var $fa8c16e591014208$var$iconName = 'face-smile';
var $fa8c16e591014208$var$width = 512;
var $fa8c16e591014208$var$height = 512;
var $fa8c16e591014208$var$aliases = [
    128578,
    "smile"
];
var $fa8c16e591014208$var$unicode = 'f118';
var $fa8c16e591014208$var$svgPathData = 'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm164.1 69.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z';
$fa8c16e591014208$exports.definition = {
    prefix: $fa8c16e591014208$var$prefix,
    iconName: $fa8c16e591014208$var$iconName,
    icon: [
        $fa8c16e591014208$var$width,
        $fa8c16e591014208$var$height,
        $fa8c16e591014208$var$aliases,
        $fa8c16e591014208$var$unicode,
        $fa8c16e591014208$var$svgPathData
    ]
};
$fa8c16e591014208$exports.faFaceSmile = $fa8c16e591014208$exports.definition;
$fa8c16e591014208$exports.prefix = $fa8c16e591014208$var$prefix;
$fa8c16e591014208$exports.iconName = $fa8c16e591014208$var$iconName;
$fa8c16e591014208$exports.width = $fa8c16e591014208$var$width;
$fa8c16e591014208$exports.height = $fa8c16e591014208$var$height;
$fa8c16e591014208$exports.ligatures = $fa8c16e591014208$var$aliases;
$fa8c16e591014208$exports.unicode = $fa8c16e591014208$var$unicode;
$fa8c16e591014208$exports.svgPathData = $fa8c16e591014208$var$svgPathData;
$fa8c16e591014208$exports.aliases = $fa8c16e591014208$var$aliases;


$0b637f68d7139cf0$exports.definition = {
    prefix: $fa8c16e591014208$exports.prefix,
    iconName: $fa8c16e591014208$exports.iconName,
    icon: [
        $fa8c16e591014208$exports.width,
        $fa8c16e591014208$exports.height,
        $fa8c16e591014208$exports.aliases,
        $fa8c16e591014208$exports.unicode,
        $fa8c16e591014208$exports.svgPathData
    ]
};
$0b637f68d7139cf0$exports.faSmile = $0b637f68d7139cf0$exports.definition;
$0b637f68d7139cf0$exports.prefix = $fa8c16e591014208$exports.prefix;
$0b637f68d7139cf0$exports.iconName = $fa8c16e591014208$exports.iconName;
$0b637f68d7139cf0$exports.width = $fa8c16e591014208$exports.width;
$0b637f68d7139cf0$exports.height = $fa8c16e591014208$exports.height;
$0b637f68d7139cf0$exports.ligatures = $fa8c16e591014208$exports.aliases;
$0b637f68d7139cf0$exports.unicode = $fa8c16e591014208$exports.unicode;
$0b637f68d7139cf0$exports.svgPathData = $fa8c16e591014208$exports.svgPathData;
$0b637f68d7139cf0$exports.aliases = $fa8c16e591014208$exports.aliases;


var $7e7e247881e84753$exports = {};
'use strict';
Object.defineProperty($7e7e247881e84753$exports, '__esModule', {
    value: true
});
var $7e7e247881e84753$var$prefix = 'fal';
var $7e7e247881e84753$var$iconName = 'tags';
var $7e7e247881e84753$var$width = 512;
var $7e7e247881e84753$var$height = 512;
var $7e7e247881e84753$var$aliases = [];
var $7e7e247881e84753$var$unicode = 'f02c';
var $7e7e247881e84753$var$svgPathData = 'M204.1 32c12.7 0 24.9 5.1 33.9 14.1L410.7 218.7c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0L14.1 270.1c-9-9-14.1-21.2-14.1-33.9L0 80C0 53.5 21.5 32 48 32l156.1 0zM36.7 247.4L209.4 420.1c12.5 12.5 32.8 12.5 45.3 0L388.1 286.6c12.5-12.5 12.5-32.8 0-45.3L215.4 68.7c-3-3-7.1-4.7-11.3-4.7L48 64c-8.8 0-16 7.2-16 16l0 156.1c0 4.2 1.7 8.3 4.7 11.3zM308.4 36.9c6.1-6.4 16.2-6.6 22.6-.5l141.3 135c52.8 50.4 52.8 134.7 0 185.1l-124.6 119c-6.4 6.1-16.5 5.9-22.6-.5s-5.9-16.5 .5-22.6l124.6-119c39.6-37.8 39.6-101 0-138.8L308.9 59.6c-6.4-6.1-6.6-16.2-.5-22.6zM104 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48z';
$7e7e247881e84753$exports.definition = {
    prefix: $7e7e247881e84753$var$prefix,
    iconName: $7e7e247881e84753$var$iconName,
    icon: [
        $7e7e247881e84753$var$width,
        $7e7e247881e84753$var$height,
        $7e7e247881e84753$var$aliases,
        $7e7e247881e84753$var$unicode,
        $7e7e247881e84753$var$svgPathData
    ]
};
$7e7e247881e84753$exports.faTags = $7e7e247881e84753$exports.definition;
$7e7e247881e84753$exports.prefix = $7e7e247881e84753$var$prefix;
$7e7e247881e84753$exports.iconName = $7e7e247881e84753$var$iconName;
$7e7e247881e84753$exports.width = $7e7e247881e84753$var$width;
$7e7e247881e84753$exports.height = $7e7e247881e84753$var$height;
$7e7e247881e84753$exports.ligatures = $7e7e247881e84753$var$aliases;
$7e7e247881e84753$exports.unicode = $7e7e247881e84753$var$unicode;
$7e7e247881e84753$exports.svgPathData = $7e7e247881e84753$var$svgPathData;
$7e7e247881e84753$exports.aliases = $7e7e247881e84753$var$aliases;


var $8b5f1b27cda2a06e$exports = {};
'use strict';
Object.defineProperty($8b5f1b27cda2a06e$exports, '__esModule', {
    value: true
});
var $8b5f1b27cda2a06e$var$prefix = 'fal';
var $8b5f1b27cda2a06e$var$iconName = 'piggy-bank';
var $8b5f1b27cda2a06e$var$width = 576;
var $8b5f1b27cda2a06e$var$height = 512;
var $8b5f1b27cda2a06e$var$aliases = [];
var $8b5f1b27cda2a06e$var$unicode = 'f4d3';
var $8b5f1b27cda2a06e$var$svgPathData = 'M272 32c34.8 0 64.5 22.2 75.5 53.3c2.9 8.3 12.1 12.7 20.4 9.8s12.7-12.1 9.8-20.4C362.3 31.2 320.8 0 272 0C216.5 0 170.4 40.4 161.5 93.4c-1.5 8.7 4.4 17 13.1 18.4s17-4.4 18.4-13.1C199.5 60.8 232.4 32 272 32zM55.2 190.3c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L36.2 164C14 175.1 0 197.8 0 222.6c0 35.7 28.5 64.7 64 65.4c0 0 0 0 0 0c0 52.4 25.2 98.8 64 128l0 48c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-16 64 0 0 16c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-29.3c25.5-11.1 47.5-28.7 64-50.7l32 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-13.3 0c-10.7-24.6-27.4-45.9-48.3-62.2l7.2-25C495.4 116.3 480 96 458.8 96L456 96c-30.5 0-58.2 12.2-78.4 32L224 128c-77.4 0-142 55-156.8 128l-1.8 0C47 256 32 241 32 222.6c0-12.7 7.2-24.2 18.5-29.9l4.7-2.3zM424 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM396.4 154.7C411 138.3 432.3 128 456 128l2.8 0-10.2 35.8c-1.9 6.7 .7 13.8 6.5 17.7c22.8 15.2 40.4 37.6 49.7 63.8c2.3 6.4 8.3 10.7 15.1 10.7l24.2 0 0 96-40.2 0c-5.3 0-10.3 2.7-13.3 7.1c-15.2 22.8-37.6 40.4-63.8 49.6C420.3 411 416 417 416 423.8l0 40.2c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-56.2c0-5.3-2.7-10.3-7.1-13.3C118.6 371.5 96 332.4 96 288c0-70.7 57.3-128 128-128l160 0s0 0 0 0l.4 0c4.6 0 8.9-1.9 11.9-5.3z';
$8b5f1b27cda2a06e$exports.definition = {
    prefix: $8b5f1b27cda2a06e$var$prefix,
    iconName: $8b5f1b27cda2a06e$var$iconName,
    icon: [
        $8b5f1b27cda2a06e$var$width,
        $8b5f1b27cda2a06e$var$height,
        $8b5f1b27cda2a06e$var$aliases,
        $8b5f1b27cda2a06e$var$unicode,
        $8b5f1b27cda2a06e$var$svgPathData
    ]
};
$8b5f1b27cda2a06e$exports.faPiggyBank = $8b5f1b27cda2a06e$exports.definition;
$8b5f1b27cda2a06e$exports.prefix = $8b5f1b27cda2a06e$var$prefix;
$8b5f1b27cda2a06e$exports.iconName = $8b5f1b27cda2a06e$var$iconName;
$8b5f1b27cda2a06e$exports.width = $8b5f1b27cda2a06e$var$width;
$8b5f1b27cda2a06e$exports.height = $8b5f1b27cda2a06e$var$height;
$8b5f1b27cda2a06e$exports.ligatures = $8b5f1b27cda2a06e$var$aliases;
$8b5f1b27cda2a06e$exports.unicode = $8b5f1b27cda2a06e$var$unicode;
$8b5f1b27cda2a06e$exports.svgPathData = $8b5f1b27cda2a06e$var$svgPathData;
$8b5f1b27cda2a06e$exports.aliases = $8b5f1b27cda2a06e$var$aliases;


var $61602bf1e925d277$exports = {};
'use strict';
Object.defineProperty($61602bf1e925d277$exports, '__esModule', {
    value: true
});
var $61602bf1e925d277$var$prefix = 'fal';
var $61602bf1e925d277$var$iconName = 'stopwatch';
var $61602bf1e925d277$var$width = 448;
var $61602bf1e925d277$var$height = 512;
var $61602bf1e925d277$var$aliases = [
    9201
];
var $61602bf1e925d277$var$unicode = 'f2f2';
var $61602bf1e925d277$var$svgPathData = 'M128 16c0-8.8 7.2-16 16-16L304 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0 0 64.6c49.4 3.8 94 24.8 127.7 57l37-37c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-38.2 38.2C416 212.6 432 256.4 432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-109.5 84.6-199.2 192-207.4L208 32l-64 0c-8.8 0-16-7.2-16-16zM48 304a176 176 0 1 0 352 0A176 176 0 1 0 48 304zm192-96l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112c0-8.8 7.2-16 16-16s16 7.2 16 16z';
$61602bf1e925d277$exports.definition = {
    prefix: $61602bf1e925d277$var$prefix,
    iconName: $61602bf1e925d277$var$iconName,
    icon: [
        $61602bf1e925d277$var$width,
        $61602bf1e925d277$var$height,
        $61602bf1e925d277$var$aliases,
        $61602bf1e925d277$var$unicode,
        $61602bf1e925d277$var$svgPathData
    ]
};
$61602bf1e925d277$exports.faStopwatch = $61602bf1e925d277$exports.definition;
$61602bf1e925d277$exports.prefix = $61602bf1e925d277$var$prefix;
$61602bf1e925d277$exports.iconName = $61602bf1e925d277$var$iconName;
$61602bf1e925d277$exports.width = $61602bf1e925d277$var$width;
$61602bf1e925d277$exports.height = $61602bf1e925d277$var$height;
$61602bf1e925d277$exports.ligatures = $61602bf1e925d277$var$aliases;
$61602bf1e925d277$exports.unicode = $61602bf1e925d277$var$unicode;
$61602bf1e925d277$exports.svgPathData = $61602bf1e925d277$var$svgPathData;
$61602bf1e925d277$exports.aliases = $61602bf1e925d277$var$aliases;


var $67b1b090374e01ef$exports = {};
'use strict';
Object.defineProperty($67b1b090374e01ef$exports, '__esModule', {
    value: true
});
var $67b1b090374e01ef$var$prefix = 'fal';
var $67b1b090374e01ef$var$iconName = 'users';
var $67b1b090374e01ef$var$width = 640;
var $67b1b090374e01ef$var$height = 512;
var $67b1b090374e01ef$var$aliases = [];
var $67b1b090374e01ef$var$unicode = 'f0c0';
var $67b1b090374e01ef$var$svgPathData = 'M96 80a48 48 0 1 1 96 0A48 48 0 1 1 96 80zm128 0A80 80 0 1 0 64 80a80 80 0 1 0 160 0zm96 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 64l117.3 0c54.2 0 98.4 42.5 101.2 96l-319.7 0c2.8-53.5 47-96 101.2-96zm0-32C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7l330.7 0c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352l-117.3 0zM512 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128A80 80 0 1 0 512 0a80 80 0 1 0 0 160zm16 64c44.2 0 80 35.8 80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9-50.1-112-112-112l-84 0c2.6 10.2 4 21 4 32l80 0zm-336 0c0-11 1.4-21.8 4-32l-84 0C50.1 192 0 242.1 0 304c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80l80 0z';
$67b1b090374e01ef$exports.definition = {
    prefix: $67b1b090374e01ef$var$prefix,
    iconName: $67b1b090374e01ef$var$iconName,
    icon: [
        $67b1b090374e01ef$var$width,
        $67b1b090374e01ef$var$height,
        $67b1b090374e01ef$var$aliases,
        $67b1b090374e01ef$var$unicode,
        $67b1b090374e01ef$var$svgPathData
    ]
};
$67b1b090374e01ef$exports.faUsers = $67b1b090374e01ef$exports.definition;
$67b1b090374e01ef$exports.prefix = $67b1b090374e01ef$var$prefix;
$67b1b090374e01ef$exports.iconName = $67b1b090374e01ef$var$iconName;
$67b1b090374e01ef$exports.width = $67b1b090374e01ef$var$width;
$67b1b090374e01ef$exports.height = $67b1b090374e01ef$var$height;
$67b1b090374e01ef$exports.ligatures = $67b1b090374e01ef$var$aliases;
$67b1b090374e01ef$exports.unicode = $67b1b090374e01ef$var$unicode;
$67b1b090374e01ef$exports.svgPathData = $67b1b090374e01ef$var$svgPathData;
$67b1b090374e01ef$exports.aliases = $67b1b090374e01ef$var$aliases;


var $51d582fce59040d0$exports = {};
'use strict';
Object.defineProperty($51d582fce59040d0$exports, '__esModule', {
    value: true
});
var $51d582fce59040d0$var$prefix = 'fal';
var $51d582fce59040d0$var$iconName = 'chart-line';
var $51d582fce59040d0$var$width = 512;
var $51d582fce59040d0$var$height = 512;
var $51d582fce59040d0$var$aliases = [
    "line-chart"
];
var $51d582fce59040d0$var$unicode = 'f201';
var $51d582fce59040d0$var$svgPathData = 'M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48L0 400c0 44.2 35.8 80 80 80l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 448c-26.5 0-48-21.5-48-48L32 48zM475.3 155.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L320 265.4l-84.7-84.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0l144-144z';
$51d582fce59040d0$exports.definition = {
    prefix: $51d582fce59040d0$var$prefix,
    iconName: $51d582fce59040d0$var$iconName,
    icon: [
        $51d582fce59040d0$var$width,
        $51d582fce59040d0$var$height,
        $51d582fce59040d0$var$aliases,
        $51d582fce59040d0$var$unicode,
        $51d582fce59040d0$var$svgPathData
    ]
};
$51d582fce59040d0$exports.faChartLine = $51d582fce59040d0$exports.definition;
$51d582fce59040d0$exports.prefix = $51d582fce59040d0$var$prefix;
$51d582fce59040d0$exports.iconName = $51d582fce59040d0$var$iconName;
$51d582fce59040d0$exports.width = $51d582fce59040d0$var$width;
$51d582fce59040d0$exports.height = $51d582fce59040d0$var$height;
$51d582fce59040d0$exports.ligatures = $51d582fce59040d0$var$aliases;
$51d582fce59040d0$exports.unicode = $51d582fce59040d0$var$unicode;
$51d582fce59040d0$exports.svgPathData = $51d582fce59040d0$var$svgPathData;
$51d582fce59040d0$exports.aliases = $51d582fce59040d0$var$aliases;


var $12eed35e051732c2$exports = {};
'use strict';
Object.defineProperty($12eed35e051732c2$exports, '__esModule', {
    value: true
});
var $bf206fd07103b72b$exports = {};
'use strict';
Object.defineProperty($bf206fd07103b72b$exports, '__esModule', {
    value: true
});
var $bf206fd07103b72b$var$prefix = 'fal';
var $bf206fd07103b72b$var$iconName = 'magnifying-glass';
var $bf206fd07103b72b$var$width = 512;
var $bf206fd07103b72b$var$height = 512;
var $bf206fd07103b72b$var$aliases = [
    128269,
    "search"
];
var $bf206fd07103b72b$var$unicode = 'f002';
var $bf206fd07103b72b$var$svgPathData = 'M384 208A176 176 0 1 0 32 208a176 176 0 1 0 352 0zM343.3 366C307 397.2 259.7 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 51.7-18.8 99-50 135.3L507.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L343.3 366z';
$bf206fd07103b72b$exports.definition = {
    prefix: $bf206fd07103b72b$var$prefix,
    iconName: $bf206fd07103b72b$var$iconName,
    icon: [
        $bf206fd07103b72b$var$width,
        $bf206fd07103b72b$var$height,
        $bf206fd07103b72b$var$aliases,
        $bf206fd07103b72b$var$unicode,
        $bf206fd07103b72b$var$svgPathData
    ]
};
$bf206fd07103b72b$exports.faMagnifyingGlass = $bf206fd07103b72b$exports.definition;
$bf206fd07103b72b$exports.prefix = $bf206fd07103b72b$var$prefix;
$bf206fd07103b72b$exports.iconName = $bf206fd07103b72b$var$iconName;
$bf206fd07103b72b$exports.width = $bf206fd07103b72b$var$width;
$bf206fd07103b72b$exports.height = $bf206fd07103b72b$var$height;
$bf206fd07103b72b$exports.ligatures = $bf206fd07103b72b$var$aliases;
$bf206fd07103b72b$exports.unicode = $bf206fd07103b72b$var$unicode;
$bf206fd07103b72b$exports.svgPathData = $bf206fd07103b72b$var$svgPathData;
$bf206fd07103b72b$exports.aliases = $bf206fd07103b72b$var$aliases;


$12eed35e051732c2$exports.definition = {
    prefix: $bf206fd07103b72b$exports.prefix,
    iconName: $bf206fd07103b72b$exports.iconName,
    icon: [
        $bf206fd07103b72b$exports.width,
        $bf206fd07103b72b$exports.height,
        $bf206fd07103b72b$exports.aliases,
        $bf206fd07103b72b$exports.unicode,
        $bf206fd07103b72b$exports.svgPathData
    ]
};
$12eed35e051732c2$exports.faSearch = $12eed35e051732c2$exports.definition;
$12eed35e051732c2$exports.prefix = $bf206fd07103b72b$exports.prefix;
$12eed35e051732c2$exports.iconName = $bf206fd07103b72b$exports.iconName;
$12eed35e051732c2$exports.width = $bf206fd07103b72b$exports.width;
$12eed35e051732c2$exports.height = $bf206fd07103b72b$exports.height;
$12eed35e051732c2$exports.ligatures = $bf206fd07103b72b$exports.aliases;
$12eed35e051732c2$exports.unicode = $bf206fd07103b72b$exports.unicode;
$12eed35e051732c2$exports.svgPathData = $bf206fd07103b72b$exports.svgPathData;
$12eed35e051732c2$exports.aliases = $bf206fd07103b72b$exports.aliases;


// Add imported icons to the library
(0, $2f7ebf3a194ce8e5$export$b839f963c7dc0e34).add((0, $3a2bc56e455da4fe$exports.faExclamationTriangle), (0, $ee9a891ea173c571$exports.faChevronRight), (0, $7bb1e697a4926ee4$exports.faChevronLeft), (0, $b0aec77b2d8e52e2$exports.faChevronUp), (0, $cebfe21aa7a84279$exports.faChevronDown), (0, $4bf79fc3e0a2622b$exports.faImages), (0, $4bf79fc3e0a2622b$exports.faImages), (0, $782edb54b9a12500$exports.faInfo), (0, $69448632564d9fae$exports.faPhone), (0, $c8f315ddd9db297b$exports.faEnvelope), (0, $60e51ca178edefdc$exports.faCheck), (0, $a7574a69e3799d7d$exports.faInfoCircle), (0, $405f53e0f028c073$exports.faQuoteLeft), (0, $1d12c6e8ecc18a6f$exports.faMapMarkerAlt), (0, $a46035823bb47651$exports.faTimes), (0, $9e51484bffff5392$exports.faFacebookF), (0, $4249215276a820c2$exports.faTwitter), (0, $0c29c32ac8432756$exports.faInstagram), (0, $b79bf6e309d792ff$exports.faYoutube), (0, $2f2aa46c8a16c007$exports.faPinterest), (0, $465446d30938e8c3$exports.faHouzz), (0, $8e1fd11806c205a6$exports.faLinkedinIn), (0, $d366bfbd4d81c0c0$exports.faXing), (0, $0b637f68d7139cf0$exports.faSmile), (0, $7e7e247881e84753$exports.faTags), (0, $8b5f1b27cda2a06e$exports.faPiggyBank), (0, $61602bf1e925d277$exports.faStopwatch), (0, $67b1b090374e01ef$exports.faUsers), (0, $51d582fce59040d0$exports.faChartLine), (0, $12eed35e051732c2$exports.faSearch));
// Kicks off the process of finding <i> tags and replacing with <svg>
(0, $2f7ebf3a194ce8e5$export$df3a06d6289f983e).watch();

})();
//# sourceMappingURL=FontAwesome.js.map
